<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1n" id="_idContainer001">
<p class="small-caps ParaOverride-1"><span class="CharOverride-1">More O’Found Titles</span></p>
<p class="text ParaOverride-2"><span class="CharOverride-2">Vertigo <br/></span>by Analog de Lēon</p>
<p class="text ParaOverride-2"><span class="CharOverride-2">Heart </span>&amp;<span class="CharOverride-2"> Stone <br/></span>by Gabriel Sage</p>
<p class="text ParaOverride-3"><span class="CharOverride-2">Riverstone </span>(music album) <br/>by Jess Adams</p>
</div>
<div class="_idGenObjectLayout-1 pb">
<div id="_idContainer002">
<img alt="" class="_idGenObjectAttribute-1" src="image/title.jpg"/>
</div>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer003">
<div><img alt="blank" src="image/blank.gif"/></div>
<p class="Book-Sub-Head _idGenParaOverride-1 t3">For the lost. </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer004">
<div><img alt="blank" src="image/blank.gif"/></div>
<p class="small-caps ParaOverride-4 t2"><span class="CharOverride-3"><a id="_idTextAnchor000"></a>Foreword</span></p>
</div>
<div class="_idGenObjectStyleOverride-1n" id="_idContainer005">
<p class="text">I think poetry and I see Whitman, roaming a countryside long since gone, notebook in hand, I see the words. I think poetry and I see Bukowski, smoke-stained, bearded, dimly lit and leaned in, I see the words. I think poetry and I see Neruda, I see Cummings, Eliot, Dickinson, Plath, I see Brautigan, Ginsberg, Kerouac, I see Maya Angelou throwing hope like a promise, I see Sarah Kay’s lyricism, Ada Limón’s tangible earthiness, I see Billy Collins and Jim Harrison, and still, I see the words.  </p>
<p class="text _idGenParaOverride-1 t">We are united by words, and we’ve always been. For far too long, the world felt far too big, and the only words we found were those close enough to be whispered, or if we were monumentally lucky, those that were handed to us in a worn-out book, dog-eared and bent in half, back pocket folded and creased from overuse. For far too long those words, that poetry, seemed to be fading into memory, an art form dying, the death rattle of a medium that has always felt vital to the fabric of the human condition. And then, a long deep breath, and lungs refilled.  </p>
<p class="text t">I think poetry and I see scraps of paper indented from old typewriters, the ghosting of letters pressed harder than the rest, if only slightly, if only randomly. I see an ocean of creativity spread across a shrinking planet, I see arms linked and passion shared and a community growing. I see the words. Some time ago, I’m not positive when, poetry started drumming instead of rattling, it started thumping wildly against its own fading, it started mattering again. I browse poetry sections in bookstores across the world on my travels now, and I am bombarded with new names, new covers, new faces filling new author photo frames on the back covers, I see the words.  </p>
<p class="text t">We are words, those we write, those we read, and those taking root inside us. We are the blossoming of them into sentences, into verse, into lyric and rhythm, we are their petals dropping and blowing across the landscapes that may separate us. We are the words, these within, and all those not yet leaked onto page or screen; we are the words, the importance of them, and the shared knowledge that someone, somewhere, feels the same as we do.  </p>
<p class="text t">I think poetry and I think of the singing of our aches. These aches, those, and all of them to come. Still, I see the words. </p>
<p class="text t _idGenParaOverride-1">—<a id="_idTextAnchor001"></a><a id="_idTextAnchor002"></a>Tyler Knott Gregson</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer008">
<p class="small-caps ParaOverride-5"><span class="CharOverride-3"><a id="_idTextAnchor003"></a>Introduction</span></p>
<p class="text ParaOverride-3 t"><span class="CharOverride-2">“My crown is called content, a crown that seldom kings (and queens) enjoy.” </span></p>
<p class="attribute n ParaOverride-6">—<a id="_idTextAnchor004"></a>Shakespeare</p>
<p class="text"><em class="italic CharOverride-5">Crown Anthology</em><span class="last-name"> is a book of community and hope, created from the singular idea that great art has the power to unite. It</span><em class="italic CharOverride-5"> </em><span class="last-name">was</span><em class="italic CharOverride-5"> </em><span class="last-name">birthed in the voices of an online poetry subculture, along the internet alleyways of social media and within the electronic exchanges of hundreds of poets and artisans. </span></p>
<p class="text t"><span class="last-name">As cofounders of Lost Poets, we have seen for ourselves the power of community. It can be the stone in a turbulent riverbed and a breaker that hardship and loneliness can’t stand against. </span><em class="italic CharOverride-5">Crown Anthology </em><span class="last-name">began as a community project to provide hope for a subculture of poets recovering from a trying time of hopelessness and lost dreams. And while it is easy to linger in any tide of darkness, we have chosen to instead write about what grew back despite the flood. </span></p>
<p class="text t _idGenParaOverride-1"><em class="italic CharOverride-5">Crown Anthology </em><span class="last-name">is a story about hope and restoration. It affirms that every soul is royal and tells the timeless story we will hopefully all get a chance to experience in our lifetime—the path from separation to wholeness, the journey to find our crown amidst the brokenness of the world. </span></p>
<p class="text t"><span class="last-name">Stand anywhere in the world right now, on any continent, in any city or capital, on top of any mountain, and the reality is that there is nowhere without injustice, without the hopeless, the helpless, or the broken. More than ever there is a global recognition of disharmony in the hearts of humans, but as the midnight of our time looms ominous in the future, hope is still an anchor. </span></p>
<p class="text t"><span class="last-name">Over recent years, a great resurgence in the art of words has enveloped the modern globe. Poetry has not been so widely popular since Ginsberg and the Beat Generation wrote the rhythm at the heart of their time into the pages of the global consciousness. </span></p>
<p class="text t"><span class="last-name">In the wake of this movement in modern poetry, a gritty and impassioned subculture formed. </span><em class="italic CharOverride-5">Crown Anthology</em><span class="last-name"> is the culmination of one hundred of those artists joined together with the common goal to use their art for healing and hope. Each of the gifted authors add their own story and voice to affirm themes of love and loss, hope and restoration, lending to </span><em class="italic CharOverride-5">Crown Anthology</em><span class="last-name"> a blend of diversity and empowerment through the lens of every race, gender, and culture, with contributors joining from nearly every major country across the globe.</span></p>
<p class="text t _idGenParaOverride-1"><em class="italic CharOverride-5">O’Lost</em><span class="last-name">. </span><em class="italic CharOverride-5">O’Found</em><span class="last-name">.</span></p>
<p class="text t"><span class="last-name">Every great tide of change began with a simple action, every great odyssey a single step. Our journey begins with O’Found. An idea more than a series, O’Found recognizes the ability for art to entrench the ills of the world with perspective and harmony. If it ignites thought, provokes action, or inspires hope, it is O’Found. Pressed into the opening pages of a book or on the corner of a canvas, O’Found is a watermark for art in resistance; it connects artists and poets from all walks of life with a singular silver cord, a shared DNA of hope. </span></p>
<p class="text t"><em class="italic CharOverride-5"><a id="_idTextAnchor005"></a></em></p>
<p class="text"><span class="last-name">O’Found is a sigil for poets and musicians, artists and revolutionaries—a means to assert voice and intention into the eternal conversation of love and living. </span></p>
<p class="text t"><span class="last-name">O’Found is the mark of </span><em class="italic CharOverride-5">purpose</em><span class="last-name">. </span></p>
<p class="text t _idGenParaOverride-1"><span class="last-name">In November of 2017, </span><em class="italic CharOverride-5">Vertigo,</em><span class="last-name"> by Analog de Lēon, was published to inaugurate the O’Found series</span><em class="italic CharOverride-5">. </em><span class="last-name">The mission of O’Found and the idea behind the book coalesce to initiate our ethos of resistance. </span><em class="italic CharOverride-5">Vertigo</em><span class="last-name"> is a book about climbing onto the rooftop of the world and standing down a great tide of darkness, a modern epic about a lost poet in retrograde twenty-two thousand miles above the skyline in defiance. It tells a story, laced with luminous layers of silk, symbol, and allegory, about the turbulence of letting go, being present, and rising up.</span></p>
<p class="text t"><span class="last-name">The second O’Found release, in the summer of 2018, was a record by troubadour and poet Jess Adams. The album, </span><em class="italic CharOverride-5">Riverstone</em><span class="last-name">, speaks to the tumultuous cycles of life that turn walls of jaded reservations into open spaces of vulnerability. It is about finding yourself in the vastness, about the rough edges of life, smoothed by the river, Lost.</span></p>
<p class="text t"><span class="last-name">The third, </span><em class="italic CharOverride-5">Heart </em><span class="last-name">&amp;</span><em class="italic CharOverride-5"> Stone,</em><span class="last-name"> by Gabriel Sage</span><em class="italic CharOverride-5">, </em><span class="last-name">is a book of poetry that examines the modern metropolitan world in all its beautiful sludge and wild truth. Holding a mirror to the vogue, it is about the complexities and anxieties that shroud contemporary life. From the winding alleys and bright lights of the city through the twisting winds in the bosom of the high desert, the story of a generation unfolds in a search for solid ground among the elusive clouds. </span></p>
<p class="text t"><span class="last-name">This book,</span><em class="italic CharOverride-5"> Crown Anthology, </em><span class="last-name">continues the tradition</span><em class="italic CharOverride-5">.</em><span class="last-name"> A poetry anthology dedicated to self-love and empowerment, to rising out of darkness and finding our way home. </span></p>
<p class="text t"><span class="last-name">Today, our community of Lost Poets is meeting, delving, grinding away in digital basements all across the world, carefully placing one more word on the page and one more wrench in the machine. Each age has its own unique challenges, but one thing remains the same: Art has the power to shake people out of apathy and into action. Art and literature can make impact in ways that no other influence can, and for the writers collected in camaraderie across these pages, this book is our proof. </span></p>
<p class="text t"><span class="last-name">Can words really make a difference? It’s not enough to talk about love. We must become love.</span></p>
<p class="text t _idGenParaOverride-1">—Gabriel Sage <span class="CharOverride-6">&amp;</span> Analog de Lēon (Chris Purifoy)</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer012">
<p class="small-caps ParaOverride-7"><span class="CharOverride-3"><a id="_idTextAnchor006"></a>Contents</span></p>
<p class="Basic-Paragraph ParaOverride-8"><a href="#/Crown_Anthologies_epub#_idTextAnchor000"><span class="CharOverride-7">Foreword</span></a></p>
<p class="Basic-Paragraph ParaOverride-9"><a href="#/Crown_Anthologies_epub#_idTextAnchor003"><span class="CharOverride-7">Introduction</span></a></p>
<p class="Basic-Paragraph ParaOverride-9"><a href="#/Crown_Anthologies_epub#_idTextAnchor007"><span class="CharOverride-8">Tender Is the Night</span></a></p>
<p class="Basic-Paragraph ParaOverride-9"><a href="#/Crown_Anthologies_epub#_idTextAnchor059"><span class="CharOverride-8">Paradise Lost</span></a></p>
<p class="Basic-Paragraph ParaOverride-9"><a href="#/Crown_Anthologies_epub#_idTextAnchor100"><span class="CharOverride-8">As I Lay Dying</span></a></p>
<p class="Basic-Paragraph ParaOverride-9"><a href="#/Crown_Anthologies_epub#_idTextAnchor147"><span class="CharOverride-8">The Sun Also Rises</span></a></p>
<p class="Basic-Paragraph ParaOverride-9"><a href="#/Crown_Anthologies_epub#_idTextAnchor197"><span class="CharOverride-8">Look Homeward, Angel</span></a></p>
<p class="Basic-Paragraph ParaOverride-8"><a href="#/Crown_Anthologies_epub#_idTextAnchor253"><span class="CharOverride-7">About the Authors</span></a></p>
<p class="Basic-Paragraph ParaOverride-8"><a href="#/Crown_Anthologies_epub#_idTextAnchor254"><span class="CharOverride-7">An Open Letter to the Lost </span></a></p>
<p class="Basic-Paragraph ParaOverride-8"><a href="#/Crown_Anthologies_epub#_idTextAnchor255"><span class="CharOverride-7">Artist Index</span></a></p>
<p class="Basic-Paragraph ParaOverride-8"><a href="#/Crown_Anthologies_epub#_idTextAnchor256"><span class="CharOverride-7">Acknowledgments</span></a></p>
<p class="Basic-Paragraph ParaOverride-8"><a href="#/Crown_Anthologies_epub#_idTextAnchor258"><span class="CharOverride-7">About Lost Poets</span></a></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer013">
<div><img alt="blank" src="image/blank.gif"/></div>
<p class="small-caps t2 _idGenParaOverride-1"><span class="CharOverride-3"><a id="_idTextAnchor007"></a>Tender Is the Night</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer014">
<p class="text"><a id="_idTextAnchor008"></a>They say we should learn</p>
<p class="text">to love ourselves before we love another,</p>
<p class="text">but I wasn’t taught how to do either.</p>
<p class="text t">When you don’t know</p>
<p class="text">how to receive,</p>
<p class="text">even giving looks like taking.</p>
<p class="text">The affection isn’<span>t liberation;</span></p>
<p class="text">it’s conspiracy.</p>
<p class="text">Trojan words of war</p>
<p class="text">disguised as compromise.</p>
<p class="text t">Then, even loving feels like losing.</p>
<p class="attribute">—<a id="_idTextAnchor009"></a><span>Chr</span>i<span>st</span>o<span>ph</span>e<span>r </span><span class="last-name">F</span><span class="last-name">errei</span><span class="last-name">r</span><span class="last-name">a</span><span class="last-name">s</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer015">
<p class="poem-title">Speak Heavy</p>
<p class="text">Speak heavy to me—</p>
<p class="text">long, stocky words,</p>
<p class="text">thick syllables,</p>
<p class="text">thumping every letter</p>
<p class="text">with haughty breaths.</p>
<p class="text t">Let me know your</p>
<p class="text">deepest thoughts,</p>
<p class="text">your most complex</p>
<p class="text">wonderings.</p>
<p class="text">Sound them out</p>
<p class="text">clearly,</p>
<p class="text">powerfully,</p>
<p class="text">to my listening ears.</p>
<p class="attribute"><span class="CharOverride-9">—<a id="_idTextAnchor010"></a>T</span>o<span class="CharOverride-9">ph</span>e<span class="CharOverride-9">r </span><span class="last-name">Kearby</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer016">
<p class="poem-title">One day I will meet a girl. </p>
<p class="text">She will be the ocean, </p>
<p class="text">and I will sail every inch of her expanse. </p>
<p class="text">I will leave poems on her pillow in the morning. </p>
<p class="text">I will leave sonnets on her skin in the evening. </p>
<p class="text">I will always find ways to hold her hand,</p>
<p class="text">beneath every table,</p>
<p class="text">on every walk,</p>
<p class="text">during every moment. </p>
<p class="text t">She will go to bed at night </p>
<p class="text">certain of her beauty. </p>
<p class="text">She will wake up in the morning</p>
<p class="text">convinced of her value. </p>
<p class="text t">She will have a key </p>
<p class="text">to explore the endless recesses </p>
<p class="text">of my mind and heart—</p>
<p class="text">I will open every door for her. </p>
<p class="text t">I will write with her a story</p>
<p class="text">that makes Shakespeare proud, </p>
<p class="text t">even the sun and moon </p>
<p class="text">will take notice and be jealous. </p>
<p class="text t">One day I will meet a girl.</p>
<p class="attribute">—<a id="_idTextAnchor011"></a>Analog<span> </span><span class="last-name">de L</span><span class="last-name">ēon</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer017">
<p class="text">We are all mad here.</p>
<p class="text">But I stand next to you,</p>
<p class="text">naked and poor,</p>
<p class="text">madly in love.</p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor012"></a>—Richard A. <span class="last-name">Camus</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer018">
<p class="text">Maybe I just want</p>
<p class="text">to live as though</p>
<p class="text">we’re the first</p>
<p class="text">to baptize</p>
<p class="text">the streets of</p>
<p class="text">New York</p>
<p class="text">with a love</p>
<p class="text l3"><span>	so grand</span></p>
<p class="text">we’d barter </p>
<p class="text"><span>our dollar dreams</span></p>
<p class="text">against a night</p>
<p class="text l3">	in Hell</p>
<p class="text">if it meant pressing</p>
<p class="text">my hips against </p>
<p class="text">yours the next</p>
<p class="text"><span>morning.</span></p>
<p class="attribute"><a id="_idTextAnchor013"></a>—<span>Alice </span><span class="last-name">Morrison</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer019">
<p class="text"><span>I am </span></p>
<p class="text">balancing</p>
<p class="text">delicately</p>
<p class="text">on the cusp </p>
<p class="text">of wanting you</p>
<p class="text">and needing you</p>
<p class="text t">that line I scratch</p>
<p class="text">so deeply in the dust</p>
<p class="text">is unsettling</p>
<p class="text">as I am in myself</p>
<p class="text t">with every part of me</p>
<p class="text">standing on end for you</p>
<p class="text t">begging</p>
<p class="text">upon your hands</p>
<p class="text">to be laid flat.</p>
<p class="attribute"><a id="_idTextAnchor014"></a>—Lauren <span class="last-name">Eden</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer020">
<p class="poem-title">This is not a poem. </p>
<p class="text">Today I was approached by a complete stranger</p>
<p class="text">while walking my dog. She said that hers had passed</p>
<p class="text">away a season ago. She’s woken up at the same time</p>
<p class="text">every morning since and walked the same path they</p>
<p class="text">walked together for 14 years. She said that she misses</p>
<p class="text">him, but finds comfort in their routine.</p>
<p class="text t">This is not a poem.</p>
<p class="text">The love in her sadness was. </p>
<p class="attribute"><a id="_idTextAnchor015"></a>—Patrick <span class="last-name">Hart</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer021">
<p class="text">it is fearful, but we crave new beginnings. </p>
<p class="text t">know I want to read in the silence of the library </p>
<p class="text">that belongs to only our collective hands. </p>
<p class="text t">you will prop your feet up on my two legs </p>
<p class="text">and we will drift through worlds </p>
<p class="text">while never moving anything but pages. </p>
<p class="text t">do you hear that in the distance? the echoing siren? </p>
<p class="text">the sailor’s call? the warning? </p>
<p class="text t">i barely do anymore. (you are my world.)</p>
<p class="text t">i move nothing if I have not moved you. </p>
<p class="text">it is true, I am consumed by love. </p>
<p class="text t">but the language of this place has always been a little maddened. </p>
<p class="text t">do you hear that in the distance? </p>
<p class="text">is it not a downpour? radio static? tree roots unwinding?</p>
<p class="text">is it not the kind of rain that washes away?</p>
<p class="text t">maybe the light has come to apologize for </p>
<p class="text">leaving, but all the anecdotes become leeches on its tongue; </p>
<p class="text">i can hide nothing through the window. </p>
<p class="text t">it even looks a little new. a little like a beginning. </p>
<p class="text t">you will not bat an eye. </p>
<p class="text">your fingers will trace the line on the page in front of you.</p>
<p class="text t">‘‘and if it is not me you are running to let the running be the quickest route to freedom. and if your legs decide to carry you to me, let our love never feel like quicksand.’’</p>
<p class="text t">(you are my world.)</p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor016"></a>—Alison <span class="last-name">Malee</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer023">
<p class="text">We do this thing, we talk without talking. </p>
<p class="text l">     Reading our bodies, page by page, exchanging         mannerisms instead of words. </p>
<p class="text t">We do this thing, we look without looking.   </p>
<p class="text l">     Evading contact, eyes up and down, taking pictures     with our minds. </p>
<p class="text t">We do this thing, we touch without touching.  </p>
<p class="text l">     Grazing while passing, skin on skin, pretending it’s     accidental. </p>
<p class="text t">We do this thing, we dance without dancing.  </p>
<p class="text l">     Colliding feet, leading and following, unknowingly        performing a waltz. </p>
<p class="text t">We do this thing, we fight without fighting.  </p>
<p class="text l">     Pushing far away, cold and stoic, striking distance       escapes us. </p>
<p class="text t">We do this thing, we feel without feeling. </p>
<p class="text l">     Abandoning our emotions, thrusting and grinding,       longing only in bed. </p>
<p class="text t">We do this thing, we love without loving.  </p>
<p class="text l">     Effortlessly giving, anything and everything, acting as       if it all means nothing. </p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor017"></a>—<span>Vivi </span><span class="last-name">Dale</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer024">
<p class="poem-title">Marrow</p>
<p class="text">My bones are stifled in more than my own skin now.</p>
<p class="text">They are stifled within your skin too—</p>
<p class="text">in the crevices of your smile</p>
<p class="text">and the soft tissue of your weary limbs.</p>
<p class="text">Because when I say I love you,</p>
<p class="text">it means I am no longer living just for myself,</p>
<p class="text">but for you, your nightmares and your dreams too.</p>
<p class="attribute"><a id="_idTextAnchor018"></a>—<a id="_idTextAnchor019"></a>Allison <span class="last-name">Theresa</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer025">
<p class="text">I accidentally swallowed </p>
<p class="text">a smile and breathed</p>
<p class="text">straight into its mouth.</p>
<p class="text">A butterfly flew </p>
<p class="text">down my throat </p>
<p class="text">and settled in my gut.</p>
<p class="text">My vision was blurry and </p>
<p class="text">a cat combed my hair.</p>
<p class="text">The ceiling had fingermarks </p>
<p class="text">and love was just a drug.</p>
<p class="attribute"><a id="_idTextAnchor020"></a>—R<a id="_idTextAnchor021"></a>. X. <span class="last-name">Bird</span><br/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer026">
<p class="poem-title">Deserve</p>
<p class="text">I don’t dare </p>
<p class="text">Question</p>
<p class="text">What I did to</p>
<p class="text">Deserve you—</p>
<p class="text">That would suggest</p>
<p class="text">I don’t believe </p>
<p class="text">That I do.</p>
<p class="text">I express gratitude,</p>
<p class="text">Instead,</p>
<p class="text">For your coming</p>
<p class="text">Into my life</p>
<p class="text">At a time when I knew</p>
<p class="text">What I deserved.</p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor022"></a>—<a id="_idTextAnchor023"></a>J. <span class="last-name">Bird</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer027">
<p class="text">I can assure you that,</p>
<p class="text">without its thorns,</p>
<p class="text">the rose would not be quite as beautiful as it is.</p>
<p class="text">The very fact that something</p>
<p class="text">so delicate, pure, sublime, and immaculate</p>
<p class="text">has contrast in its character—</p>
<p class="text">sharp edges that can draw blood—</p>
<p class="text">make roses worthy of adoration.</p>
<p class="text">And this is the problem with most people—</p>
<p class="text">they all demand beauty,</p>
<p class="text">but hardly any of them</p>
<p class="text">are bold enough to hold it.</p>
<p class="attribute"><a id="_idTextAnchor024"></a>—<a id="_idTextAnchor025"></a>Daniel <span class="last-name">Saint</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer028">
<p class="text">Love me loud like clanking bottles</p>
<p class="text">tied to a galloping horse, and when </p>
<p class="text">they shatter I will pick up every </p>
<p class="text">single piece of glass so we don’t</p>
<p class="text">have to watch our step. Or would</p>
<p class="text">you rather tread amongst these</p>
<p class="text">fragments like eggshells and pretend</p>
<p class="text">you aren’t bleeding, but you’d be a </p>
<p class="text">fool to think I don’t care enough to </p>
<p class="text">notice. My faith matches the</p>
<p class="text">highness of which I carry your name</p>
<p class="text">and how I look for it in everything</p>
<p class="text">like a star amidst the daylight, like</p>
<p class="text">happiness in my wildest dreams. </p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor026"></a>—<a id="_idTextAnchor027"></a>A<span>nth</span>o<span>ny </span><span class="last-name">D</span><span class="last-name">e</span><span class="last-name">sm</span><span class="last-name">o</span><span class="last-name">nd</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer029">
<p class="text">Her skin was the canvas for a new day—</p>
<p class="text">I knew as I touched every particle of her body.</p>
<p class="text">Her mouth, the oxygen to breathe—</p>
<p class="text">as I kissed her over and over.</p>
<p class="text">Those beautiful eyes contained the colors</p>
<p class="text">to stop seeing life in black and white.</p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor028"></a><a id="_idTextAnchor029"></a>—Richard A. <span class="last-name">Camus</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer030">
<p class="text">Let me hold your hurt </p>
<p class="text">and quiet the petulant aches that reign your moods.</p>
<p class="text">Let me look upon you with my love-soaked eyes </p>
<p class="text">and absorb every piece of your beauty.</p>
<p class="text">Let me fortify the deficiency of unanswered desires </p>
<p class="text">and feed you an abundance of lust.</p>
<p class="text">Let me love you with the tenderness of my touch </p>
<p class="text">and drench your desiccated body </p>
<p class="text">with the rainfall of my affection.</p>
<p class="text">Let me give you everything you seek and deserve,</p>
<p class="text">because we both know, </p>
<p class="text">she never will.</p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor030"></a>—<span>Vivi </span><span class="last-name">Dale</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer031">
<p class="poem-title">A Grander Life</p>
<p class="text">We took cheap wine</p>
<p class="text">up the mountain, sat with </p>
<p class="text">our legs dangling from its </p>
<p class="text">face and pretended we lived</p>
<p class="text">a grander life in the city </p>
<p class="text">below our feet.</p>
<p class="text">For those few hours,</p>
<p class="text">I felt like everything was okay,</p>
<p class="text">with you in my arms and </p>
<p class="text">cheap wine on our lips.</p>
<p class="attribute"><a id="_idTextAnchor031"></a>—<a id="_idTextAnchor032"></a>Daniel <span class="last-name">Walsh</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer032">
<p class="poem-title">Eternity</p>
<p class="text">I’ll love you for eternity.</p>
<p class="text">That’s what we all say.</p>
<p class="text">We say that our hearts will</p>
<p class="text">still be beating</p>
<p class="text">for only each other</p>
<p class="text">even after we both decay</p>
<p class="text">and turn to ash.</p>
<p class="text">How cliché.</p>
<p class="text t">Before death,</p>
<p class="text">my last emotion will be</p>
<p class="text">adoration for you.</p>
<p class="text">This adoration, my darling,</p>
<p class="text">will flow into our universe</p>
<p class="text">and create this new life—</p>
<p class="text">our soil will grow</p>
<p class="text">new trees and daffodils.</p>
<p class="text t">I might not be able to promise</p>
<p class="text">a love for eternity,</p>
<p class="text">but when I’m gone</p>
<p class="text t">you will find my love</p>
<p class="text">in the nearest baby willow tree—</p>
<p class="text">ever-growing.</p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor033"></a>—<a id="_idTextAnchor034"></a><span>Sica </span><span class="last-name">Saccone</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer033">
<p class="poem-title">Evolution</p>
<p class="text">It is remarkable,</p>
<p class="text">The evolution of self.</p>
<p class="text">The normalization of a situation.</p>
<p class="text">How these two </p>
<p class="text">Progressions </p>
<p class="text">Can run parallel to one another</p>
<p class="text">And never quite meet.</p>
<p class="text t">In times when I would be </p>
<p class="text">Free of trouble,</p>
<p class="text">I would stagnate.</p>
<p class="text">Possibly regress.</p>
<p class="text">It is in times of hardship</p>
<p class="text">Or challenge, however, when</p>
<p class="text">I </p>
<p class="text">Become.</p>
<p class="text t">In the face of anger,</p>
<p class="text">I seek peace.</p>
<p class="text">In the face of entitlement, of loss,</p>
<p class="text">I seek gratitude.</p>
<p class="text">In the face of ignorance,</p>
<p class="text">I seek knowledge.</p>
<p class="text">In the face of unkindness,</p>
<p class="text">I seek empathy. </p>
<p class="attribute"><a id="_idTextAnchor035"></a>—J. <span class="last-name">Bird</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer034">
<p class="text">He somehow makes</p>
<p class="text">eternity make sense.</p>
<p class="text">I’m not sure</p>
<p class="text">if I believe</p>
<p class="text">in love</p>
<p class="text">at first sight.</p>
<p class="text t">All I know</p>
<p class="text">is that</p>
<p class="text">the second my eyes</p>
<p class="text">met his,</p>
<p class="text">I started counting</p>
<p class="text">to infinity.</p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor036"></a>—<a id="_idTextAnchor037"></a>Cindy <span class="last-name">Cherie</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer035">
<p class="text">Wait</p>
<p class="text">until </p>
<p class="text">it </p>
<p class="text">feels</p>
<p class="text">like</p>
<p class="text">home.</p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor038"></a>—<span>Analog </span><span class="last-name">de Lēon</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer036">
<p class="text">If you ever forget</p>
<p class="text">what love looks like,</p>
<p class="text">go watch the arrival gates</p>
<p class="text">at the airport.</p>
<p class="text">Go see day-old flowers</p>
<p class="text">on decade-old tombstones,</p>
<p class="text">or a man sitting on a bench</p>
<p class="text">sharing a cannoli with</p>
<p class="text">his dog.</p>
<p class="text">Listen to a song.</p>
<p class="text">Admire a painting.</p>
<p class="text t">Love is literally everywhere.</p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor039"></a>—<a id="_idTextAnchor040"></a>Michael <span class="last-name">Layao</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer037">
<p class="text">My happiness lies in yours.</p>
<p class="text">So, in the future if it turns out</p>
<p class="text">that I am crazily, madly, </p>
<p class="text">irrevocably in love with you</p>
<p class="text">but you don’t feel the same </p>
<p class="text">way, I will let go for you.</p>
<p class="text">Even though it will absolutely</p>
<p class="text">kill me on the inside. Even</p>
<p class="text">though I might be broken</p>
<p class="text">to the point of no return,</p>
<p class="text">I will let you go for you.</p>
<p class="text">Because my happiness lies</p>
<p class="text">in your happiness. </p>
<p class="text t"><span class="CharOverride-2"><a id="_idTextAnchor041"></a>—a paradox.</span></p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor042"></a>—Ruby <span class="last-name">Dhal</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer038">
<p class="poem-title">Still</p>
<p class="text">I rub the sleep from my eyes </p>
<p class="text">and stumble hazily out of bed.</p>
<p class="text t">I twist the blinds open,</p>
<p class="text">put some water on the stove,</p>
<p class="text">and take the silkiest of throws out of the cabinet.</p>
<p class="text t">I crawl back in bed and prop myself up</p>
<p class="text">on the old wooden headboard.</p>
<p class="text t">Still,</p>
<p class="text">it is not the sun I feel filtering through the panels,</p>
<p class="text">not the warm tea running into my stomach,</p>
<p class="text">and not the cashmere on my skin that is it.</p>
<p class="text t">Still,</p>
<p class="text">the light, warmth, and softness I am feeling</p>
<p class="text">comes from the body sleeping messy and quiet </p>
<p class="text">next to me.</p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor043"></a>—N. <span class="last-name">Wong</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer039">
<p class="text">The sky </p>
<p class="text l2">     is full of the moon</p>
<p class="text l">   and my head</p>
<p class="text l2">     is full of you.</p>
<p class="text">I melt for you.</p>
<p class="text">I surrender to you.</p>
<p class="text">I want your grip on my hips</p>
<p class="text l">   and bruises left on my skin</p>
<p class="text l2">     in the shape</p>
<p class="text l">   of your fingertips.</p>
<p class="attribute"><a id="_idTextAnchor044"></a>—Natalie <span class="last-name">Jensen</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer040">
<p class="text">She is my</p>
<p class="text">wonderland,</p>
<p class="text">and I can’t</p>
<p class="text">ask for more.</p>
<p class="text t">And he is the</p>
<p class="text">rabbit hole</p>
<p class="text">I’d tumble</p>
<p class="text">through over</p>
<p class="text">and over for.</p>
<p class="attribute">—<a id="_idTextAnchor045"></a>Richard A. <span class="last-name">Camus</span> and <a id="_idTextAnchor046"></a>Raquel <span class="last-name">Franco</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer041">
<p class="text">if i lie still on my back</p>
<p class="text">my stomach will howl and gurgle </p>
<p class="text">and it doesn’t ever stop</p>
<p class="text">i have always been full of noise</p>
<p class="text">and there are hollows</p>
<p class="text">wee crescent moons at the base of my spine</p>
<p class="text">like thumb prints </p>
<p class="text t">there are a dozen small things that make</p>
<p class="text">a good poem</p>
<p class="text">and none of them are really talents </p>
<p class="text">or grammar</p>
<p class="text">mostly just inhaling the words</p>
<p class="text">falling in love with the person in them</p>
<p class="text">and</p>
<p class="text">realizing it is you. </p>
<p class="attribute"><a id="_idTextAnchor047"></a>—<span class="last-name">featherdownsoul</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer042">
<p class="poem-title">Storm</p>
<p class="text">She is the shred of light</p>
<p class="text">I need in my charcoal nights,</p>
<p class="text">the lightning of my storm.</p>
<p class="text">Against all my better judgment,</p>
<p class="text">I always hope she will electrify me . . .</p>
<p class="text">just once.</p>
<p class="attribute"><a id="_idTextAnchor048"></a>—<span>Sica </span><span class="last-name">Saccone</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer043">
<p class="poem-title">Synthetic</p>
<p class="text">Suddenly, hands over your face—<br/>coffee steams from a white mug on the table—<br/>closed on one side,<br/>a bartender gave us a quiet place<br/>to visit.  </p>
<p class="text t">In silence I stare <br/>under yellow lights.</p>
<p class="text t">Tears fall from wrists, elbows on stomach,<br/>wrinkles on fingers, drops glisten<br/>on black down jacket,</p>
<p class="text t">heat dissolves past hairline—<br/>strands of yarn pasted on canvas.<br/>A metal shard forms the chair’s back.<br/>Fruit peels creased, coated in wax, tar smeared<br/>below skin—charcoal shapes breasts and waist—<br/>melted Styrofoam.<br/></p>
<p class="attribute"><a id="_idTextAnchor049"></a>—Chase <span class="last-name">Maser</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer044">
<p class="text">I need your arms, </p>
<p class="text">not your words.</p>
<p class="attribute"><a id="_idTextAnchor050"></a>—<span>Vivi </span><span class="last-name">Dale</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer045">
<p class="text">I’m questioning the validity </p>
<p class="text">of the ground beneath me.</p>
<p class="text">You see, I’m falling for you, </p>
<p class="text">for the soft behind your eyes.</p>
<p class="text">I’m lost in the corners of your smile </p>
<p class="text">and the waves crashing in your hair,</p>
<p class="text">languishing and drifting away to somewhere high,</p>
<p class="text">an altitude from where I don’t want to come down,</p>
<p class="text">from where I don’t even try.</p>
<p class="text">This is what it means to be swept away.</p>
<p class="attribute"><a id="_idTextAnchor051"></a>—A.R. <span class="last-name">Asher</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer046">
<p class="text">Our hearts cannot grow stronger</p>
<p class="text">without knowing the feeling of pain.</p>
<p class="text">Just as wildflowers cannot stand tall</p>
<p class="text">without the showers of rain. </p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor052"></a>—S.L. <span class="last-name">Gray</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer047">
<p class="text">I still remember the way</p>
<p class="text">you used to hold my hands,</p>
<p class="text">and how it was the only time</p>
<p class="text">they ever stopped<br/></p>
<p class="text t">s h aki n g.</p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor053"></a>—Andrew <span class="last-name">Durst</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer048">
<p class="text">All I want </p>
<p class="text">is something real,</p>
<p class="text">something that is</p>
<p class="text">terrifying to the touch</p>
<p class="text">but far too beautiful </p>
<p class="text">to ever let go of.</p>
<p class="attribute"><a id="_idTextAnchor054"></a>—<span class="last-name">faraway</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer049">
<p class="text">When the workday has trampled over me—</p>
<p class="text">bloody and bruised—</p>
<p class="text">I come home to rub her feet . . .</p>
<p class="text">for they would never tread on me.</p>
<p class="attribute"><a id="_idTextAnchor055"></a>—C. <span class="last-name">Noel</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer050">
<p class="text">You know what breaks me? </p>
<p class="text">When someone is visibly excited </p>
<p class="text">about a feeling or an idea or a hope </p>
<p class="text">or a risk taken, and they tell you about it </p>
<p class="text">but preface it with: “Sorry, this is dumb but—”.</p>
<p class="text t">Don’t do that.</p>
<p class="text t">I don’t know who came here before me, </p>
<p class="text">who conditioned you to think</p>
<p class="text">you had to apologize or feel obtuse. </p>
<p class="text">But not here. Dream so big it’s silly. </p>
<p class="text">Laugh so hard it’s obnoxious. </p>
<p class="text">Love so much it’s impossible.</p>
<p class="text t">And don’t you ever feel</p>
<p class="text">unintelligent. And don’t you ever</p>
<p class="text">apologize. And don’t you ever</p>
<p class="text">shrink so you can squeeze yourself </p>
<p class="text">into small places and small minds.</p>
<p class="text t">Grow. It’s a big world. There’s room.</p>
<p class="text">You fit. I promise. </p>
<p class="attribute"><a id="_idTextAnchor056"></a>—Owen <span class="last-name">Lindley</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer051">
<p class="poem-title">Once Again</p>
<p class="text">You’re like déjà vu to me—</p>
<p class="text">the new feels old.</p>
<p class="text">The here and now feels like</p>
<p class="text">a familiar there and then.</p>
<p class="text t">I’ve often wondered how much</p>
<p class="text">fits in a first glance,</p>
<p class="text">and I finally understood</p>
<p class="text">the night we met.</p>
<p class="text">It’s in-between the words</p>
<p class="text">and thoughts</p>
<p class="text">and whiskey sips,</p>
<p class="text">when perfect</p>
<p class="text">becomes a tense of time.</p>
<p class="text t">You are this moment,</p>
<p class="text">this moment is you,</p>
<p class="text">and I feel like this has all happened before.</p>
<p class="attribute"><a id="_idTextAnchor057"></a>—Gabriel <span class="last-name">Sage</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer052">
<p class="text">Find somebody for whom you’re willing to grow.</p>
<p class="text">Start with yourself. </p>
<p class="text">Build yourself, </p>
<p class="text">prove your worth to yourself,</p>
<p class="text">support yourself, </p>
<p class="text">value yourself, </p>
<p class="text">and love yourself so much that</p>
<p class="text">putting your heart back on the line again </p>
<p class="text">doesn’t feel like a risk</p>
<p class="text">but, instead, feels like an opportunity </p>
<p class="text">for love and self-love.</p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor058"></a>—Horacio <span class="last-name">Jones</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer053">
<div><img alt="blank" src="image/blank.gif"/></div>
<p class="small-caps _idGenParaOverride-1 t2"><span class="CharOverride-3"><a id="_idTextAnchor059"></a>Paradise Lost</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer054">
<p class="text">someone once told me</p>
<p class="text">the significance</p>
<p class="text">of staying</p>
<p class="text t">only lasts as long</p>
<p class="text">as there is</p>
<p class="text">tenderness, too.</p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor060"></a>—Alison <span class="last-name">Malee</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer055">
<p class="text">They say gravity has a maximum speed—</p>
<p class="text">as if we can only fall so fast and so hard.</p>
<p class="text">I guess there is nothing new</p>
<p class="text">in the way we collapse,</p>
<p class="text">but I have stood on a mountain</p>
<p class="text">as high as the moon,</p>
<p class="text">then, with one blink,</p>
<p class="text">found myself so low in the valley</p>
<p class="text">that the skyline</p>
<p class="text">was lost from view.</p>
<p class="text">There is no limit</p>
<p class="text">to the speed of falling love.</p>
<p class="text t">I fell for her in eight days.</p>
<p class="text">It took years to climb back out of that hole.</p>
<p class="text">I’m still scaling silver ladders from the chasm</p>
<p class="text">as my thoughts collide with paper.</p>
<p class="text t">We fall in love and then fall from love.</p>
<p class="text">Just once I want to love without falling.</p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor061"></a>—<span>Analog </span><span class="last-name">de Lēon</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer056">
<p class="text">Anyone who has ever said</p>
<p class="text">that silence is not deafening</p>
<p class="text">has never heard her voice</p>
<p class="text">and had to go without it.</p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor062"></a>—Kate <span class="last-name">Foster</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer057">
<p class="poem-title">Echo Skin</p>
<p class="text">I cannot look</p>
<p class="text">at my naked skin</p>
<p class="text">anymore.</p>
<p class="text">I cannot look at my body</p>
<p class="text">without seeing</p>
<p class="text">a skin</p>
<p class="text">of tainted memories,</p>
<p class="text">taut on top of mine.</p>
<p class="text">My own palms repel from it—</p>
<p class="text">every touch feels like his,</p>
<p class="text">an echo</p>
<p class="text">of all the times his hands</p>
<p class="text">met it.</p>
<p class="text">I await the day</p>
<p class="text">this skin falls away,</p>
<p class="text">when I feel beautiful</p>
<p class="text">again.</p>
<p class="attribute"><a id="_idTextAnchor063"></a>—N. <span class="last-name">Wong</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer058">
<p class="text">Letting go is a</p>
<p class="text">mysterious place</p>
<p class="text">often traveled </p>
<p class="text">to alone.</p>
<p class="text">You will show up</p>
<p class="text">defeated, but</p>
<p class="text">you will leave</p>
<p class="text">with a brand new</p>
<p class="text">sword. </p>
<p class="attribute"><a id="_idTextAnchor064"></a>—Erin <span class="last-name">Van Vuren</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer059">
<p class="text">Like clouds,</p>
<p class="text">your heart</p>
<p class="text">breaks after</p>
<p class="text">the storm.</p>
<p class="text t">You break like dawn</p>
<p class="text">into the early morn.</p>
<p class="text">You don’t break in two;</p>
<p class="text">you break into.</p>
<p class="text">This is how you break free</p>
<p class="text">and break through.</p>
<p class="attribute"><a id="_idTextAnchor065"></a>—T. <span class="last-name">Weiss</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer060">
<p class="poem-title">After Hours</p>
<p class="text">“Babe, I feel restless,” I whisper,</p>
<p class="text">knowing you won’t hear me</p>
<p class="text">as you sleep by my side,</p>
<p class="text">and I watch the ceiling fan playing games</p>
<p class="text">with the shadows.</p>
<p class="text">Let me tell you all the things</p>
<p class="text">I’ve told the night</p>
<p class="text">too many times before.</p>
<p class="attribute"><a id="_idTextAnchor066"></a>—Gabriel <span class="last-name">Sage</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer061">
<p class="poem-title">I Am in the Silences</p>
<p class="text">I cannot control </p>
<p class="text">My mouth.</p>
<p class="text">When I want to say</p>
<p class="text">The most important </p>
<p class="text">Words,</p>
<p class="text">My lips will not</p>
<p class="text">Part, </p>
<p class="text">My teeth are ivory bars</p>
<p class="text">And will not let them out.</p>
<p class="text t">When I want to say </p>
<p class="text">Nothing,</p>
<p class="text">My tongue catapults</p>
<p class="text">Words into the air,</p>
<p class="text">Because soundlessness</p>
<p class="text">Is so much more </p>
<p class="text">Exposing</p>
<p class="text">And I am wary </p>
<p class="text">Of my own vulnerability.</p>
<p class="text t">Quiet me.</p>
<p class="text">It is there that you will</p>
<p class="text">Discover who I am.</p>
<p class="text">I am in the silences.</p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor067"></a>—J. <span class="last-name">Bird</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer062">
<p class="text">I am </p>
<p class="text">always </p>
<p class="text">surprised </p>
<p class="text">when </p>
<p class="text">someone </p>
<p class="text">hurts me </p>
<p class="text t">no matter </p>
<p class="text">how many times </p>
<p class="text">I’ve been </p>
<p class="text">hurt before </p>
<p class="text t">and I can’t </p>
<p class="text">seem to </p>
<p class="text">work out </p>
<p class="text t">if that </p>
<p class="text">is the definition </p>
<p class="text">of innocence </p>
<p class="text t">or insanity.</p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor068"></a>—Lauren <span class="last-name">Eden</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer063">
<p class="text">I was so drawn to you.</p>
<p class="text">I felt as if</p>
<p class="text">I was meant to find you,</p>
<p class="text">but there’s something</p>
<p class="text">so uneasy about you and me.</p>
<p class="text">So, if you look ahead</p>
<p class="text">into your life,</p>
<p class="text">and not seeing me</p>
<p class="text">doesn’t break your heart,</p>
<p class="text">then I must have been</p>
<p class="text">meant to lose you.</p>
<p class="text"> </p>
<p class="attribute"><a id="_idTextAnchor069"></a>—Natalie <span class="last-name">Jensen</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer064">
<p class="poem-title">The Fragmented Soul</p>
<p class="text">He was torn in half </p>
<p class="text">Tormented at night</p>
<p class="text">But made himself whole </p>
<p class="text">With morning’s first light; </p>
<p class="text t">Two sides</p>
<p class="text">Held tight</p>
<p class="text">Bound together</p>
<p class="text">By lies. </p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor070"></a>—Emilija <span class="last-name">Blum</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer065">
<p class="text">We chased infinity </p>
<p class="text">as though our love</p>
<p class="text">wasn’t enough.</p>
<p class="text">These days</p>
<p class="text">I’m tired of running,</p>
<p class="text">I’ve grown to love </p>
<p class="text">the home</p>
<p class="text">that we’ve built</p>
<p class="text">in each other,</p>
<p class="text">even if it’s just</p>
<p class="text">temporary. </p>
<p class="attribute _idGenParaOverride-1"><a id="_idTextAnchor071"></a>—Almaz <span class="last-name">A.</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer066">
<p class="poem-title">Hairline Fracture</p>
<p class="text">She is gone,</p>
<p class="text">and all that</p>
<p class="text">is left is</p>
<p class="text">despair</p>
<p class="text">and her hair</p>
<p class="text">lined in the fabric</p>
<p class="text">of everything</p>
<p class="text">that I was.</p>
<p class="text">All at once,</p>
<p class="text">everything is</p>
<p class="text">fractured.</p>
<p class="attribute"><a id="_idTextAnchor072"></a>— T. <span class="last-name">Weiss</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer067">
<p class="text">You call me every now and then,</p>
<p class="text">complaining of the remnants of</p>
<p class="text">muddled bitters and orange sugars</p>
<p class="text">on your tongue.</p>
<p class="text">Nothing can quite wash me down,</p>
<p class="text">but you can’t quite have any seconds.</p>
<p class="text t">I indulge you as you settle for</p>
<p class="text">the sound of my voice.</p>
<p class="text">You salivate and imagine,</p>
<p class="text">swallow and remember,</p>
<p class="text">that old-fashioned love that is me.</p>
<p class="text t">At first taste, </p>
<p class="text">she was exquisite—</p>
<p class="text">the remedy for another long day,</p>
<p class="text">caramel with a kick.</p>
<p class="text">I drank her back too quickly,</p>
<p class="text">like I needed every sip,</p>
<p class="text">and I did.</p>
<p class="text t">So now the ice is melting</p>
<p class="text">with what’s left of the bitters,</p>
<p class="text t">and I’m missing that old-fashioned love</p>
<p class="text">but ready for another drink.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor073"></a><a id="_idTextAnchor074"></a>Allison <span class="last-name">Theresa</span> and <a id="_idTextAnchor075"></a>Gabriel <span class="last-name">Sage</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer068">
<p class="text">I cling to summer</p>
<p class="text">as it slips from my fingertips</p>
<p class="text t">dreams of you</p>
<p class="text">swirl into my teacup</p>
<p class="text t">I take a sip</p>
<p class="text">and try to ingest</p>
<p class="text">the last traces of you</p>
<p class="text t">with the faintly lit summer</p>
<p class="text">dancing away in hues of gold and rain</p>
<p class="text t">life reverts into its old fashion</p>
<p class="text">comfortable</p>
<p class="text">and safe</p>
<p class="text t">maybe I am ready</p>
<p class="text">to let go of summer</p>
<p class="text">because it means holding once again</p>
<p class="text">totally</p>
<p class="text">to you</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor076"></a><span>Gabrielle </span><span class="last-name">Dufrene</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer069">
<p class="text">I wonder what your days are like now</p>
<p class="text">and if they’re anything like mine</p>
<p class="text">daydreaming constantly </p>
<p class="text">and staring at the skyline</p>
<p class="text">when you get done with work</p>
<p class="text">do you yell out, “Honey, I’m home”?</p>
<p class="text">If you do, our days would differ,</p>
<p class="text">in my home, I’m all alone.</p>
<p class="text">Do you put your headphones on</p>
<p class="text">and think about our past lives?</p>
<p class="text">Or do you recycle all the things we said,</p>
<p class="text">our favorite lyrics or movie lines?</p>
<p class="text">And when you lie your head down at night,</p>
<p class="text">do you count problems or sheep?</p>
<p class="text">I’ve been counting everything but you</p>
<p class="text">and to this day, I still can’t sleep. </p>
<p class="attribute">—<a id="_idTextAnchor077"></a>Leya <span class="last-name">Noir</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer070">
<p class="text">freedom is relative to where</p>
<p class="text">you are and where you are not.</p>
<p class="text">to where you have been and</p>
<p class="text">the miles yet to go.</p>
<p class="text">it’s an elusive, curious mirage</p>
<p class="text">i walk toward wondering </p>
<p class="text">if the gap between the two</p>
<p class="text">will ever be bridged. </p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor078"></a>a<span>ng</span>ie<span> </span><span class="last-name">a</span><span class="last-name">ll</span><span class="last-name">e</span><span class="last-name">n</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer071">
<p class="text">The strings that suspend me</p>
<p class="text">from heaven</p>
<p class="text">are just strong enough</p>
<p class="text">to keep me</p>
<p class="text">from hell.</p>
<p class="text">I am a tease to</p>
<p class="text">the earth below me,</p>
<p class="text">the ground would swallow me whole</p>
<p class="text">if I fell.</p>
<p class="text"> </p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor079"></a>Caroline <span class="last-name">White</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer072">
<p class="text">Then I am reminded</p>
<p class="text">that I must live</p>
<p class="text">and that I have no idea</p>
<p class="text">what that means without her.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor080"></a><span>Chr</span>i<span>st</span>o<span>ph</span>e<span>r </span><span class="last-name">F</span><span class="last-name">e</span><span class="last-name">rr</span><span class="last-name">ei</span><span class="last-name">r</span><span class="last-name">a</span><span class="last-name">s</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer073">
<p class="poem-title">Small Talks</p>
<p class="text">Within the borders of our fleeting conversation,</p>
<p class="text">words bounce back and forth between us—</p>
<p class="text">with no purpose,</p>
<p class="text">direction or destination,</p>
<p class="text">they get lost</p>
<p class="text">under all the other voices.</p>
<p class="text">Speaking about nothing.</p>
<p class="text">Drinking about something.</p>
<p class="text">Just one more word</p>
<p class="text">before you leave</p>
<p class="text">and blow cigarette smoke into the night.</p>
<p class="attribute">—<a id="_idTextAnchor081"></a>Gabriel <span class="last-name">Sage</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer074">
<p class="poem-title">Tomorrow</p>
<p class="text">Endings are never simple.</p>
<p class="text t">There will be times when you won’t be able to see</p>
<p class="text">a tomorrow without someone in your todays,</p>
<p class="text">but those days will pass and tomorrow will come . . .</p>
<p class="text">for you are not defined by anyone but yourself,</p>
<p class="text">and with time you will find that even the sharpest pains</p>
<p class="text">can dull to nothing more than a distant ache.</p>
<p class="text t">Trust me when I say that</p>
<p class="text">you will learn to live, love, and smile once again.</p>
<p class="attribute">—<a id="_idTextAnchor082"></a><span>Becca </span><span class="last-name">Lee</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer075">
<p class="text">I am moving on but stuck in reverse—</p>
<p class="text">between the ears,</p>
<p class="text">gumming up gears,</p>
<p class="text">running through the years,</p>
<p class="text">wondering how I ended my story on sour notes</p>
<p class="text">on more than one occasion</p>
<p class="text">by gnashing my teeth,</p>
<p class="text">crying for one more chance to never let go of the past,</p>
<p class="text">like a Christmas tree still lit up in July.</p>
<p class="attribute">—<a id="_idTextAnchor083"></a><span class="last-name">The Poetry Bandit</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer076">
<p class="text">A part of it was real</p>
<p class="text">I think.</p>
<p class="text">It had to be.</p>
<p class="text">Because it didn’t start from nothing;</p>
<p class="text">you can’t break nothing.</p>
<p class="attribute">—<a id="_idTextAnchor084"></a><span class="last-name">Kay</span>il <span class="last-name">Crow</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer077">
<p class="text">Her eyes were ripe,</p>
<p class="text">violet,</p>
<p class="text">and hanging,</p>
<p class="text">like bursting late autumn concords,</p>
<p class="text">that, for no reason other than</p>
<p class="text">the carelessness</p>
<p class="text">of man,</p>
<p class="text">remained yet unpicked.</p>
<p class="text t">Fools.</p>
<p class="attribute">—<a id="_idTextAnchor085"></a><a id="_idTextAnchor086"></a><span>Michael Fawaz</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer078">
<p class="text">You shake me to my core with your hello,</p>
<p class="text">and foolishly I inhale every word that comes after,</p>
<p class="text">feeling them crawling their way down my lungs,</p>
<p class="text">swimming through my veins,</p>
<p class="text">making their way to my heart</p>
<p class="text">to suffocate my arteries.</p>
<p class="text">You had me at hello,</p>
<p class="text">and I never stood a chance at breathing.</p>
<p class="attribute">—<a id="_idTextAnchor087"></a><a id="_idTextAnchor088"></a>M. <span class="last-name">FireChild</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer079">
<p class="text">I am the last leaf</p>
<p class="text">that hangs on</p>
<p class="text">beyond fall</p>
<p class="text">I outlast the</p>
<p class="text">death of winter</p>
<p class="text">and am still there</p>
<p class="text">while the new buds</p>
<p class="text">form in the spring</p>
<p class="text">longing for just</p>
<p class="text">one more summer. </p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor089"></a>stacie <span class="last-name">martin</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer080">
<p class="text">For once I’d like to strip myself of this</p>
<p class="text">imprinted billboard I’ve learned to plaster </p>
<p class="text">on the busiest street of my heart—that </p>
<p class="text">says, “Right person, wrong time.”</p>
<p class="attribute">—<a id="_idTextAnchor090"></a>Olivia <span class="last-name">Ku</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer081">
<p class="text">I know it is tiresome, my love,</p>
<p class="text">to keep swinging your sledgehammer</p>
<p class="text">at my facade</p>
<p class="text">only to get a glimpse of what is inside.</p>
<p class="text">But I was not always like this, you know?</p>
<p class="text">They made me this way.</p>
<p class="text">No one ever cared enough about my insides</p>
<p class="text">to keep swinging.</p>
<p class="text">So please do not stop.</p>
<p class="text">I want you to ruin me.</p>
<p class="attribute">—<a id="_idTextAnchor091"></a>Emina <span class="last-name">Gašpar-Vrana</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer082">
<p class="text">We are survivors—broken and defeated—</p>
<p class="text">standing on a foreign shore.</p>
<p class="text">Waves of the past crash over our feet,</p>
<p class="text">washing away both sin and memory.</p>
<p class="text">Come to where we are kings</p>
<p class="text">and see our strength—</p>
<p class="text">the place where time and shadows</p>
<p class="text">aren’t measured by length.</p>
<p class="attribute">—<a id="_idTextAnchor092"></a>Adan <span class="last-name">Portwood</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer083">
<p class="text">Why sit with paupers</p>
<p class="text">when you can stand with queens?</p>
<p class="text">You’ve earned your royalty,</p>
<p class="text">the purple regalia of your struggle</p>
<p class="text">draped proudly across your shoulders.</p>
<p class="text">You won’t sit high on a throne</p>
<p class="text">like others do.</p>
<p class="text">You know what it’s like</p>
<p class="text">to beg in the streets,</p>
<p class="text">to look up and see nothing but walls.</p>
<p class="text">You will stand proud though</p>
<p class="text">with your king at your side,</p>
<p class="text">and always bow low</p>
<p class="text">to help those who desire to rid themselves</p>
<p class="text">of the chains they carry,</p>
<p class="text">and trade them in for the</p>
<p class="text">crown they’ve earned.</p>
<p class="attribute">—<a id="_idTextAnchor093"></a>J. L. <span class="last-name">Wyman</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer084">
<p class="text">Don’t allow the pains of your past</p>
<p class="text">to grow on you like a phantom limb.</p>
<p class="text">Use your ruins to build</p>
<p class="text">beautiful kingdoms and castles,</p>
<p class="text">rather than allowing them to tear you down.</p>
<p class="text">I don’t deserve it and neither do you.</p>
<p class="text">Protect your soul.</p>
<p class="text">Become its mate.</p>
<p class="text">You are royalty.</p>
<p class="text">We all are.</p>
<p class="attribute">—<a id="_idTextAnchor094"></a>Soeline <span class="last-name">Bosari</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer085">
<p class="text">I held on until my hands</p>
<p class="text">began to bleed . . .</p>
<p class="text t">My palms were scarred</p>
<p class="text">and I no longer knew the</p>
<p class="text">difference between my</p>
<p class="text">lifelines and the</p>
<p class="text">reminders you left upon</p>
<p class="text">them . . .</p>
<p class="attribute">—<a id="_idTextAnchor095"></a><a id="_idTextAnchor096"></a><span class="last-name">A.D.Woods</span><br/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer086">
<p class="text">You are who you are,</p>
<p class="text">and, no matter how hard you try</p>
<p class="text">pretending to be whole,</p>
<p class="text">I know you are a broken puzzle,</p>
<p class="text">trying to find all the right pieces.</p>
<p class="text">I honor that part of you</p>
<p class="text">that yearns to be put back together.</p>
<p class="attribute">—<a id="_idTextAnchor097"></a><a id="_idTextAnchor098"></a>Adrian Michael <span class="last-name">Green</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer087">
<p class="text">We hang like a chandelier</p>
<p class="text">in an empty church.</p>
<p class="text">Derelict and damned,</p>
<p class="text">we are cursed</p>
<p class="text">to have our lights burn</p>
<p class="text">for no one.</p>
<p class="attribute">—<a id="_idTextAnchor099"></a><span class="last-name">The Poetry Bandit</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer088">
<div><img alt="blank" src="image/blank.gif"/></div>
<p class="small-caps t2 _idGenParaOverride-1"><span class="CharOverride-3"><a id="_idTextAnchor100"></a>As I Lay Dying</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer089">
<p class="poem-title">Speaking</p>
<p class="text">Silence speaks volumes—</p>
<p class="text">of pages,</p>
<p class="text">of chapters,</p>
<p class="text">of novels,</p>
<p class="text">of never-ending distance</p>
<p class="text">placed between family,</p>
<p class="text">between friends,</p>
<p class="text">between lovers.</p>
<p class="text t">But words . . .</p>
<p class="text">Oh, words, how clumsily they fall,</p>
<p class="text">dislodging from your throat</p>
<p class="text">in a tumbling, dizzying downpour</p>
<p class="text">of vowels</p>
<p class="text">and syllables</p>
<p class="text">and mistakes.</p>
<p class="text t">Words</p>
<p class="text">are sharper than the pinprick of a needle,</p>
<p class="text">enough now.</p>
<p class="text t">hear me when i say,</p>
<p class="text">heat escapes open mouths</p>
<p class="text">even when you trust them.</p>
<p class="text t">the sun and the dawn</p>
<p class="text">all exhale steady breaths.</p>
<p class="text t">and lips find</p>
<p class="text">other lips</p>
<p class="text">find other lips</p>
<p class="text t">find other</p>
<p class="text">lips. </p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor101"></a>Alison <span class="last-name">Malee</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer091">
<p class="text">somethin’ about </p>
<p class="text">sharks and </p>
<p class="text">lions</p>
<p class="text"><span class="last-name CharOverride-6">&amp;</span> pissed off</p>
<p class="text">junkyard dogs</p>
<p class="text t">somethin’ about</p>
<p class="text">baring your</p>
<p class="text">teeth</p>
<p class="text">and letting them</p>
<p class="text">gleam</p>
<p class="text t">somethin’ about</p>
<p class="text">lettin’ the next</p>
<p class="text">year know</p>
<p class="text">you’re human</p>
<p class="text t">but you fight</p>
<p class="text">like somethin’</p>
<p class="text">otherworldly</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor102"></a><a id="_idTextAnchor103"></a>Jarod <span class="last-name">W.</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer092">
<p class="text">I don’t think I could ever be a great writer.</p>
<p class="text">I can’t be honest enough</p>
<p class="text">when I write on these paper walls.</p>
<p class="text">So much of me is hidden</p>
<p class="text">beneath a veneer of strength</p>
<p class="text">that isolates me from everyone.</p>
<p class="text t">Being strong</p>
<p class="text">has always helped me build </p>
<p class="text">communities for other people,</p>
<p class="text">but almost no one really knows why </p>
<p class="text">I sometimes wake up breathless</p>
<p class="text">and waste entire days </p>
<p class="text">trying to catch it again.</p>
<p class="text t">My father told me</p>
<p class="text">we connect in our weakness</p>
<p class="text">not our strength.</p>
<p class="text">I can’t stop thinking about that.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor104"></a><span>Analog </span><span class="last-name">de Lēon</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer093">
<p class="text">You may know your worth,</p>
<p class="text">but that doesn’t mean you value it.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor105"></a>Horacio <span class="last-name">Jones</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer094">
<p class="text">What’s to be made of sea and silt,</p>
<p class="text t">of obstruction,</p>
<p class="text">of the porous and eroding?</p>
<p class="text t">What of an indisposed Atlantic coast,</p>
<p class="text t">left with nothing,</p>
<p class="text">nothing but names,</p>
<p class="text t">naively engraved</p>
<p class="text">though permanence has no favor</p>
<p class="text">here among the drifts? </p>
<p class="text t">I have taken a tally of fingers</p>
<p class="text">in their tasting the wind,</p>
<p class="text t">felt coercion as a passerby,</p>
<p class="text">to move,</p>
<p class="text">to follow,</p>
<p class="text">to heed,</p>
<p class="text t">yet the bottoms of my feet are rough </p>
<p class="text">from this directionless roaming.</p>
<p class="text t">I have whispered breathy sonnets</p>
<p class="text">in smoke-filled exhalations of wild plumes,</p>
<p class="text t">risen with the rapid nature of currents,</p>
<p class="text">to seek,</p>
<p class="text">to speak to hope,</p>
<p class="text t">yet even still coal is not of my makeup,</p>
<p class="text t">to shrivel just to be desired,</p>
<p class="text">to be fuel,</p>
<p class="text">to be consumed.</p>
<p class="text t">What’s to be made of </p>
<p class="text">fire and ember?</p>
<p class="text t">of discord?</p>
<p class="text">of what is left dry?</p>
<p class="text t">I will not be left to burn.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor106"></a>Sarah <span class="last-name">Maria</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer096">
<p class="poem-title">Plucked</p>
<p class="text">You give me wings</p>
<p class="text">just to pluck each feather</p>
<p class="text">from my back</p>
<p class="text">and watch me crash</p>
<p class="text">back to earth.</p>
<p class="attribute">—<a id="_idTextAnchor107"></a>Topher <span class="last-name">Kearby</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer097">
<p class="text">I am more than warm flesh. The scarred skin that covers my organs and cushions my bones wasn’t meant for anything more. That sway in my hips is nothing more than something I was forced to learn when I barely knew how to walk.</p>
<p class="text t">I am more than the wintry-ocean blue swimming in my eyes. That glint is nothing more than panic. That wide-eyed expression is nothing more than fear. </p>
<p class="text t">I am more than the breath in my lungs. A vessel to break and belittle. I was born with lungs meant to breathe air and a voice that is meant to be heard, not stifled.</p>
<p class="text t">I am intelligence—capable of making up my own mind. I am heart—loving as hard as I can on the ones that matter.  I am soul—caring, gentle.</p>
<p class="text t">I am more than the pain I’ve endured. I am more than what you made out of me. I am everything you never could be.</p>
<p class="text t">And I bet that’s not something you expected.</p>
<p class="attribute">—<a id="_idTextAnchor108"></a>Sarah <span class="last-name">Doughty</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer098">
<p class="poem-title">Carnivore</p>
<p class="text">You feasted on my carrion—</p>
<p class="text">a meal perfectly prepared</p>
<p class="text">for a savage beast</p>
<p class="text">with an appetite</p>
<p class="text">only my broken soul</p>
<p class="text">could satisfy.</p>
<p class="attribute">—<a id="_idTextAnchor109"></a>Allison <span class="last-name">Theresa</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer099">
<p class="text">Don’t </p>
<p class="text">tell me </p>
<p class="text">you love </p>
<p class="text">the rain </p>
<p class="text t">when you </p>
<p class="text">don’t stay </p>
<p class="text">to watch </p>
<p class="text">her dry </p>
<p class="text t">after </p>
<p class="text">she’s fallen </p>
<p class="text">for you.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor110"></a>Lauren <span class="last-name">Eden</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer100">
<p class="text">Each and every one of us has</p>
<p class="text">a beast imprisoned inside.</p>
<p class="text">The tragedy of man happens when</p>
<p class="text">he unleashes the beast</p>
<p class="text">and imprisons the man.</p>
<p class="attribute">—<a id="_idTextAnchor111"></a>Daniel <span class="last-name">Saint</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer101">
<p class="text">Maybe just maybe</p>
<p class="text">your soulmate is nothing more</p>
<p class="text">than a reflection of yourself,</p>
<p class="text">teaching you to love every perfect</p>
<p class="text">hard to reach imperfection of you.</p>
<p class="text">Because if you can love someone in spite </p>
<p class="text">of theirs, why not yours.</p>
<p class="attribute">—<a id="_idTextAnchor112"></a><span class="last-name">a.c.sparks</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer102">
<p class="text">I am not the budding flower on the tree you sit under.</p>
<p class="text">I am not the sweet fruit that you savor </p>
<p class="text">on a summer afternoon.</p>
<p class="text">I am not the many leaves that wither away in the cold.</p>
<p class="text">I am the roots— </p>
<p class="text">running deeper, stronger,</p>
<p class="text">firmly holding every branch, </p>
<p class="text">every fruit, every leaf together.</p>
<p class="text">I am what you cannot see,</p>
<p class="text">yet I am a simple truth,</p>
<p class="text">infusing life in the complexities.</p>
<p class="text">I am what nurtures.</p>
<p class="text">I am the foundations of what you seek.</p>
<p class="text">I exist to create.</p>
<p class="attribute">—<a id="_idTextAnchor113"></a><span class="last-name">Paradox</span><span class="last-name"> </span><span class="last-name CharOverride-10">&amp;</span><span class="last-name"> </span><span class="last-name">Metaphors</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer103">
<p class="text">Anger is a mask</p>
<p class="text">that I have grown to</p>
<p class="text">wear a little too well.</p>
<p class="attribute">—<a id="_idTextAnchor114"></a>Kate <span class="last-name">Foster</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer104">
<p class="text">Dear Anger,</p>
<p class="text t">You are sadness turned inward.</p>
<p class="text">Take the balm of forgiveness</p>
<p class="text">and apply it over your heart.</p>
<p class="text t">Love,</p>
<p class="text">Your Spirit</p>
<p class="attribute">—<a id="_idTextAnchor115"></a>Simi <span class="last-name">Fromen</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer105">
<p class="text">With the sun rising at my back</p>
<p class="text">and dark skies ahead,</p>
<p class="text">I drove into the storm</p>
<p class="text">just to see what colors </p>
<p class="text">might lay beyond.</p>
<p class="text">I took the toll roads,</p>
<p class="text">and paid my fair share.</p>
<p class="text">The rain starts to roar,</p>
<p class="text">crashing on the roof</p>
<p class="text">of this gunmetal car.</p>
<p class="text">So I hit the gas,</p>
<p class="text">just to make it last.</p>
<p class="text">My chest carries an anchor </p>
<p class="text">hanging from a rope in my mind</p>
<p class="text">knotted together with heartstrings</p>
<p class="text">but it’s full of mud</p>
<p class="text">it’s wrapped in thorns</p>
<p class="text">it’s weighed down by the guilt</p>
<p class="text">of love lost along the way</p>
<p class="text">And my cinder block toes slow</p>
<p class="text">me down</p>
<p class="text">on this long road home</p>
<p class="text">to something that was nothing</p>
<p class="text">and the fire that died within.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor116"></a><a id="_idTextAnchor117"></a><span class="last-name">Unrulywords</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer106">
<p class="poem-title">How Women Get Burned</p>
<p class="text">I’m an abandoned house, </p>
<p class="text">looted and ransacked</p>
<p class="text">vandalized, burned. </p>
<p class="text t">Choking on ash. </p>
<p class="text">No exceptions to your </p>
<p class="text">scorched Earth policy. </p>
<p class="text t">Turn around. </p>
<p class="text">Do you think you’re the first </p>
<p class="text">man to light me on fire?</p>
<p class="text t">Years ago, covered in dust,</p>
<p class="text">dilapidated, divorced, decaying. </p>
<p class="text">This was how you found me. </p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor118"></a>Emilija <span class="last-name">Blum</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer107">
<p class="poem-title">Oxymoronic Love</p>
<p class="text">This is the loudest silence I have ever heard.</p>
<p class="text">Your absence is the strongest presence I have ever felt,</p>
<p class="text">and this hatred has got to be the realest love</p>
<p class="text">that ever existed.</p>
<p class="attribute">—<a id="_idTextAnchor119"></a><a id="_idTextAnchor120"></a>Dru <span class="last-name">Anthony</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer108">
<p class="text">Pull for push</p>
<p class="text">You into me</p>
<p class="text">Up against the wall</p>
<p class="text">As we tear them down</p>
<p class="text">Tell me the things</p>
<p class="text">Within your head</p>
<p class="text">I want to hear</p>
<p class="text">What you hold</p>
<p class="text">Within long hard kisses</p>
<p class="text">Reaching our souls</p>
<p class="text">Let’s taste the passion</p>
<p class="text">Nibbling at our necks</p>
<p class="text">With our hands to hold</p>
<p class="text">Wrapping around each other</p>
<p class="text">Pushing into the pull</p>
<p class="attribute">—<a id="_idTextAnchor121"></a><a id="_idTextAnchor122"></a>Joshua Ryan <span class="last-name">Stewart</span> <br/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer109">
<p class="text">My computer keeps trying,</p>
<p class="text">over and over,</p>
<p class="text">to capitalize the letter <em class="italic _idGenCharOverride-1">i</em>.</p>
<p class="text t">(Maybe that’s our problem.)</p>
<p class="attribute">—<a id="_idTextAnchor123"></a><a id="_idTextAnchor124"></a>Jef <span class="last-name">Joslin</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer110">
<p class="text">I’m a woman of strength—</p>
<p class="text">comfortable in my skin,</p>
<p class="text">lost in my thoughts,</p>
<p class="text">and found in my words,</p>
<p class="text t">always holding my heart</p>
<p class="text">but never my tongue.</p>
<p class="attribute">—<a id="_idTextAnchor125"></a><a id="_idTextAnchor126"></a>Yasmin A. <span class="last-name">Gomez</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer111">
<p class="text">Some nights I lie awake with this ache</p>
<p class="text">in my chest where your head</p>
<p class="text">would’ve been as our words lingered</p>
<p class="text">in the darkness.</p>
<p class="text t">Though you let the weight of you</p>
<p class="text">fall on me, it still felt light,</p>
<p class="text">like my fingers as they grazed</p>
<p class="text">up and down your back—</p>
<p class="text">easy, like the I love you’s</p>
<p class="text">I whispered into your hair.</p>
<p class="text t">The part I miss most were the moments</p>
<p class="text">when you’d drum your fingers</p>
<p class="text">along my chest and smile—</p>
<p class="text">how I’d feel your happiness</p>
<p class="text">against my skin.</p>
<p class="text t">I know the night will end</p>
<p class="text">and I’ll see you again,</p>
<p class="text">but any moment without you</p>
<p class="text">is too long for me.</p>
<p class="attribute">—<a id="_idTextAnchor127"></a><a id="_idTextAnchor128"></a>Daren <span class="last-name">Colbert</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer112">
<p class="poem-title">Beliefs</p>
<p class="text">I believe in contradicting myself. </p>
<p class="text">In proving myself wrong as often as</p>
<p class="text">I prove myself right. </p>
<p class="text">I believe in making mistakes</p>
<p class="text">Until the lesson sticks</p>
<p class="text">Or the error loses its appeal.</p>
<p class="text">I believe in energy.</p>
<p class="text">In manifesting it.</p>
<p class="text">In carving out the people and situations </p>
<p class="text">That drink it from me.</p>
<p class="text">I believe in intention.</p>
<p class="text">In being mindful of what it is.</p>
<p class="text">In getting behind the tongue </p>
<p class="text">Of the intention of others’.</p>
<p class="text">I believe in intimacy.</p>
<p class="text">In unadulterated communication.</p>
<p class="text">In holding a gaze and in holding a hand.</p>
<p class="text">I believe in gratitude.</p>
<p class="text">In acknowledging all the goodness, the love.</p>
<p class="text">In knowing letting go is an act of grace.</p>
<p class="text t">I believe in allowing myself.</p>
<p class="text">I believe in denying myself.</p>
<p class="text t">I believe in the power and the delicacy of words.</p>
<p class="text">In how important they are to get right (honesty, honestly).</p>
<p class="text">In how easily they can cause misdirection (they’re known to pretty themselves up).</p>
<p class="text">I believe in kindness.</p>
<p class="text">In its power and its contagiousness.</p>
<p class="text">In how it needs to come with a backbone and an antenna.</p>
<p class="text t">I believe in being comfortable.</p>
<p class="text">In being myself.</p>
<p class="text">In understanding what that means.</p>
<p class="attribute">—<a id="_idTextAnchor129"></a>J. <span class="last-name">Bird</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer114">
<p class="text">She leaves with her spirit still intact.</p>
<p class="text">No longer is it pinned</p>
<p class="text">to the wall of her lover.</p>
<p class="text">Too many times it has been used</p>
<p class="text">for other things</p>
<p class="text">besides love.</p>
<p class="text">Now it’s hers again to wear with pride.</p>
<p class="attribute">—<a id="_idTextAnchor130"></a>Zachry K. <span class="last-name">Douglas</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer115">
<p class="poem-title">Autopsy</p>
<p class="text">Repairing my father’s house I saw the window trim</p>
<p class="text">come loose from the wall outside. Dead wood</p>
<p class="text">from too much rain and humidity; tall trees</p>
<p class="text">blocked sunlight, moisture filled its pores.</p>
<p class="text t">I set the tools down moved the ladder underneath</p>
<p class="text">and climbed up to assess the damage; an old wound,</p>
<p class="text">nails rusted through, only flesh held it together.</p>
<p class="text">I ripped it off; blood dripped down my arms.</p>
<p class="text t">My hands scraped away skin to uncover the dermis;</p>
<p class="text">bone-dry panels, humming air circulation, running water, electricity, steady cadences. Leaned back on the rung, I paused.</p>
<p class="text t">Gutters sagged from brown wet leaves—</p>
<p class="text">patches of roof tile layered with moss.</p>
<p class="text">I watched cardinals peck seeds from a feeder</p>
<p class="text">on the porch; cracked shells and open hearts.</p>
<p class="text t">I looked up at the trees—limbs rigor mortis—</p>
<p class="text">then called a service to cut them down.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor131"></a>Chase <span class="last-name">Maser</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer116">
<p class="text">Do not reduce yourself</p>
<p class="text">to anything less than</p>
<p class="text">who you are meant to be,</p>
<p class="text">so that your heart will not engulf people</p>
<p class="text">who are not meant to survive</p>
<p class="text">within its vastness.</p>
<p class="text t">The unworthy may drown,</p>
<p class="text">but the worthy will learn how to swim.</p>
<p class="attribute">—<a id="_idTextAnchor132"></a>Emina <span class="last-name">Gašpar-Vrana</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer117">
<p class="poem-title">Bear.</p>
<p class="text">Toward the forbidden</p>
<p class="text">to the signs of the prisoned </p>
<p class="text">woven salts rest;</p>
<p class="text">undying.</p>
<p class="text t">As drips take</p>
<p class="text">to the rising waters of time,</p>
<p class="text">your thoughts sail</p>
<p class="text">through the air to new heights.</p>
<p class="text t">So I’ll take your weight</p>
<p class="text">and burn my own</p>
<p class="text">upon this everyday emery</p>
<p class="text">that tremors across</p>
<p class="text">true luster. </p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor133"></a><span class="last-name">A.Kelman</span><a id="_idTextAnchor134"></a> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer118">
<p class="poem-title">Novel Romance</p>
<p class="text">As much as you want to be my endless novel,</p>
<p class="text">I have a feeling you will be the subtle differences</p>
<p class="text">between my confessions and my regrets—</p>
<p class="text">the once promising, crumbled pieces of paper</p>
<p class="text">by the waste bin.</p>
<p class="text">Long stories were never my strong suit.</p>
<p class="attribute">—<a id="_idTextAnchor135"></a>Allison <span class="last-name">Theresa</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer119">
<p class="text">I used to be straight, fragile,</p>
<p class="text">a package to handle with caution.</p>
<p class="text">I bowed my spine to the feet of men</p>
<p class="text">who never wanted me to rise higher than hip bones.</p>
<p class="text">Then I broke, cracked my spine, and was forced to bend.</p>
<p class="text">Now I am curves, zigzags, open, and flexible—</p>
<p class="text">free to dodge bullets that prey upon the weak.</p>
<p class="text">I am proud of my breaking—my bending of bones—</p>
<p class="text">for it led me to mountains with strength at their peaks.</p>
<p class="attribute">—<a id="_idTextAnchor136"></a><span>Raquel </span><span class="last-name">Franco</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer120">
<p class="text">a queen isn’t arrogant.</p>
<p class="text">a queen is self-confident.</p>
<p class="attribute">—<a id="_idTextAnchor137"></a>Adrian Michael <span class="last-name">Green</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer121">
<p class="text">Come back to me.</p>
<p class="text">Come back when you have nothing left</p>
<p class="text">because right now I see you holding onto</p>
<p class="text">that shred of what you call pride—</p>
<p class="text">I call it ego, and they’d call it bravery.</p>
<p class="text">But you are not brave.</p>
<p class="text">You should call it a day,</p>
<p class="text">but you are holding on to this notion that</p>
<p class="text">you are, in some way, like everyone else,</p>
<p class="text">just another person on this planet</p>
<p class="text">who can kill themselves slowly</p>
<p class="text">in moderation.</p>
<p class="text">Such a thing does not exist.</p>
<p class="text">It is—and will be—engraved on tombstones</p>
<p class="text">up one side and down the other</p>
<p class="text">of this long road home.</p>
<p class="text">When you get there, give it up. All of it.</p>
<p class="text">All of the bullshit screaming that</p>
<p class="text">you need a glimpse of Heaven bathed in booze</p>
<p class="text">in order to wash yourself in the sweet light</p>
<p class="text">of recognition.</p>
<p class="text">So come back to me.</p>
<p class="text">But come back to me when you have nothing.</p>
<p class="attribute">—<a id="_idTextAnchor138"></a><span class="last-name">The Poetry Bandit</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer122">
<p class="text">I have learned that I am a delicacy</p>
<p class="text">and that one day someone will</p>
<p class="text">whisper my name under their breath</p>
<p class="text">just to savor my acquired taste.</p>
<p class="attribute">—<a id="_idTextAnchor139"></a>Dru <span class="last-name">Anthony</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer123">
<p class="text">The stars will only ever be</p>
<p class="text">a mild-mannered backdrop</p>
<p class="text">to your beautifully reckless</p>
<p class="text">midnight silhouette.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor140"></a>Kristina <span class="last-name">Fanning</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer124">
<p class="text">Humans are selfish beings.</p>
<p class="text">We are centered on ourselves.</p>
<p class="text">We crave attention.</p>
<p class="text">We do good to feel good.</p>
<p class="text">We pat ourselves on the back</p>
<p class="text">and pout when we are not recognized</p>
<p class="text">for our “selflessness.”</p>
<p class="text">We even love selfishly,</p>
<p class="text">expecting the same love we give,</p>
<p class="text">demanding it,</p>
<p class="text">with the mindset that we deserve it.</p>
<p class="text">What makes us so special?</p>
<p class="text">Aren’t we all broken, messed up souls</p>
<p class="text">wandering through life,</p>
<p class="text">pretending we have the answers?</p>
<p class="text">So, love others with no expectations,</p>
<p class="text">prerequisites, clauses, or conditions.</p>
<p class="text">Give without the desire to be noticed</p>
<p class="text">and applauded.</p>
<p class="text">Change the world</p>
<p class="text">because the world needs us</p>
<p class="text">to look outside of ourselves.</p>
<p class="text t2b">Smile because the sun is shining</p>
<p class="text">or because the rain falling on your</p>
<p class="text">face makes you feel alive.</p>
<p class="attribute">—<a id="_idTextAnchor141"></a><a id="_idTextAnchor142"></a>Rose <span class="last-name">C.L.</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer125">
<p class="text">I am savage,</p>
<p class="text">wind </p>
<p class="text">and wild hair.</p>
<p class="text">No apologies.</p>
<p class="text">Free.</p>
<p class="text">Protector,</p>
<p class="text">with gritted teeth,</p>
<p class="text">holding on </p>
<p class="text">to all I deserve.</p>
<p class="attribute">—<a id="_idTextAnchor143"></a><span>Raquel </span><span class="last-name">Franco</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer126">
<p class="text">Get lonely.</p>
<p class="text">Get so lonely your teeth rattle with it.</p>
<p class="text">In the emptiness you will find beauty.</p>
<p class="text">You will find yourself</p>
<p class="text">Soft and gentle. Dewy with hope.</p>
<p class="text"> </p>
<p class="attribute">—<a id="_idTextAnchor144"></a><a id="_idTextAnchor145"></a>Salma <span class="last-name">El-Wardany</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer127">
<p class="text">she’s the kind of queen</p>
<p class="text">that knows her crown</p>
<p class="text">isn’t on her head but</p>
<p class="text">in her soul.</p>
<p class="attribute">—<a id="_idTextAnchor146"></a>Adrian Michael <span class="last-name">Green</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer128">
<div><img alt="blank" src="image/blank.gif"/></div>
<p class="small-caps t2 _idGenParaOverride-1"><span class="CharOverride-3"><a id="_idTextAnchor147"></a>The Sun Also Rises</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer129">
<p class="text">Reach. </p>
<p class="text">Never stop reaching.</p>
<p class="text">When you think there is nothing left to grab,</p>
<p class="text">there is always more.</p>
<p class="text">The universe is infinite and still unfolding,</p>
<p class="text">and even as you see creation undone,</p>
<p class="text">it is all the while birthing something new,</p>
<p class="text">something further, </p>
<p class="text">something reachable.</p>
<p class="attribute">—<a id="_idTextAnchor148"></a><span>Analog </span><span class="last-name">de Lēon</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer130">
<p class="text">Courage, dear heart.</p>
<p class="text">We’ve had our book burned before,</p>
<p class="text">and each time we write it over,</p>
<p class="text">it just keeps getting better and better.</p>
<p class="attribute">—<a id="_idTextAnchor149"></a><span class="last-name">The Poetry Bandit</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer131">
<p class="text">we were busy</p>
<p class="text">dancing and crying.</p>
<p class="text">sticking our fingers</p>
<p class="text">into the empty spaces</p>
<p class="text">in our chests and talking</p>
<p class="text">about all the ways</p>
<p class="text">we could fill them.</p>
<p class="text t">and life didn’t hurt so much then. </p>
<p class="text t">and we were happy enough.</p>
<p class="text t">and it was precious.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor150"></a>anna <span class="last-name">corniffe</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer132">
<p class="text">It amazes me that after every winter—</p>
<p class="text">the bitter cold and deep freeze—</p>
<p class="text">that life returns with spring.</p>
<p class="text t">The flowers blossom, the birds sing,</p>
<p class="text">and trees stretch their limbs,</p>
<p class="text">reaching toward the sun again.</p>
<p class="text t">So if all the world can die once a year</p>
<p class="text">and come back to tell the tale,</p>
<p class="text">then we can awaken from the darkest despair,</p>
<p class="text">and find a way to love again.</p>
<p class="attribute">—<a id="_idTextAnchor151"></a>Madalyn <span class="last-name">Beck</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer133">
<p class="poem-title">Mettle</p>
<p class="text">Still I survive.</p>
<p class="text">Even when you grind my head into the dirt.</p>
<p class="text">Even when you whisper in my ear</p>
<p class="text">to keep my eyes wide at night.</p>
<p class="text">Still I survive.</p>
<p class="attribute">—<a id="_idTextAnchor152"></a>Dave <span class="last-name">Wise</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer134">
<p class="text">Fulfillment is not so much about being at the peak.</p>
<p class="text">It’s about looking at your blistered and calloused </p>
<p class="text">hands and feet,</p>
<p class="text">knowing that you climbed </p>
<p class="text">that goddamned mountain bare.</p>
<p class="attribute">—<a id="_idTextAnchor153"></a>Daniel <span class="last-name">Saint</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer135">
<p class="text">Never underestimate the weight of a</p>
<p class="text">pebble by its size, it still hurts.</p>
<p class="text">Neither a drop of water by its quantity,</p>
<p class="text">it can easily drown you.</p>
<p class="text">Nor an ember from a long-dead fire,</p>
<p class="text">it will still set a forest ablaze.</p>
<p class="text">Or a simple transgressing crack,</p>
<p class="text">which can cause colossal devastation along its path.</p>
<p class="text">Small things are easily overlooked.</p>
<p class="text">Never let them pass you by so easily.</p>
<p class="text">They can have a vast and great turning effect in</p>
<p class="text">your life, without you even realizing.</p>
<p class="text">Appreciate the little things too.</p>
<p class="attribute">—<a id="_idTextAnchor154"></a>Salman <span class="last-name">Bharadia</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer136">
<p class="text">Allow hope to bloom like spring daffodils—</p>
<p class="text">the harbinger of magnificent change,</p>
<p class="text">the testimony of beholding beauty,</p>
<p class="text">the inevitable arrival of newness,</p>
<p class="text">the end to a cold dullness.</p>
<p class="text t">Wear hope like a spring season.</p>
<p class="text">After a morbid winter, it must arrive.</p>
<p class="attribute">—<a id="_idTextAnchor155"></a><span class="last-name">Paradox </span><span class="last-name CharOverride-10">&amp;</span><span class="last-name"> Metaphors</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer137">
<p class="poem-title">Flower Child</p>
<p class="text">It’s easy for a flower to bloom </p>
<p class="text">while feeding off the rays of the sun,</p>
<p class="text">but a wildflower that is able to flourish</p>
<p class="text">in the light of the moon and stars, through the cold dirt,</p>
<p class="text">brings me rays of courage, hope of perseverance.</p>
<p class="text">If something so fragile </p>
<p class="text">could brave the darkness and survive,</p>
<p class="text">then maybe so can I.</p>
<p class="attribute">—<a id="_idTextAnchor156"></a><span>Sica </span><span class="last-name">Saccone</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer138">
<p class="text">holes in fences,</p>
<p class="text">cracks in walls,</p>
<p class="text">that’s all I can offer, love.</p>
<p class="text">i’ve been building for so long.</p>
<p class="text">my chest—</p>
<p class="text">my barricades—</p>
<p class="text">could you break them down?</p>
<p class="text">i’m ready to meet you,</p>
<p class="text">meet you on that soft,</p>
<p class="text">soft ground.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor157"></a>Jess <span class="last-name">Adams</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer139">
<p class="text">No one should live in a world</p>
<p class="text">where their hearts keep the same steady rhythm.</p>
<p class="text">Live breathless.</p>
<p class="attribute">—<a id="_idTextAnchor158"></a><span>H. </span><span class="last-name">Christoffersen</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer140">
<p class="text">Be inspired by truth</p>
<p class="text">Invigorated with what you have</p>
<p class="text">Excited to play the part of you,</p>
<p class="text">And you might just live </p>
<p class="text">Happily ever after.</p>
<p class="text">After all,</p>
<p class="text">A fairytale is just another story told . . .</p>
<p class="text">Until you decide to make it yours.</p>
<p class="attribute">—<a id="_idTextAnchor159"></a>Krystal <span class="last-name">Lorraine</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer141">
<p class="text">your heart is only as</p>
<p class="text">fragile as you let it be.</p>
<p class="text">rip it out of your</p>
<p class="text">chest and let the</p>
<p class="text">world see. showing</p>
<p class="text">people that you feel</p>
<p class="text">something only makes</p>
<p class="text">you stronger. and one</p>
<p class="text">day, someone will come</p>
<p class="text">along and love you, not</p>
<p class="text">just for the way you</p>
<p class="text">shine, but for the</p>
<p class="text">scratches in your</p>
<p class="text">armor. especially  </p>
<p class="text">the ones that</p>
<p class="text">run the deepest.</p>
<p class="text"> </p>
<p class="attribute">—<a id="_idTextAnchor160"></a>Zack <span class="last-name">Grey</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer142">
<p class="poem-title">Vox Populi</p>
<p class="text">Don’t tell me futile words,</p>
<p class="text">of paperweight sentiments and smokescreen promises.</p>
<p class="text">For my wounds were licked clean by your words, by your healing tongue.</p>
<p class="text t">In the dead of night, I can still hear you</p>
<p class="text">as if my scars are gently whispering,</p>
<p class="text">“You are so much more than that.”</p>
<p class="attribute">—<a id="_idTextAnchor161"></a>Brittin <span class="last-name">Oakman</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer143">
<p class="text">I have found no other resting place for my weary heart</p>
<p class="text">except within the deep grooves </p>
<p class="text">of carefully chosen words</p>
<p class="text">scribed here in this book of hopes.</p>
<p class="text t">The paper rips and cries</p>
<p class="text">as I tear through years of painful memories.</p>
<p class="text">The words burn through thin layers of earth,</p>
<p class="text">as thoughts burn through thin layers of life.</p>
<p class="text t">Writing it all down</p>
<p class="text">in hopes of traveling through the thick of it all</p>
<p class="text">to a place where the paper won’t hurt as bad as I do.</p>
<p class="attribute">—<a id="_idTextAnchor162"></a><a id="_idTextAnchor163"></a>Allison <span class="last-name">Theresa</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer144">
<p class="text">One of the most challenging</p>
<p class="text">things in life is learning</p>
<p class="text">how to be still.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor164"></a>Jef <span class="last-name">Joslin</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer145">
<p class="text">For days gone by and rocket ships</p>
<p class="text">lost in the flurry of our flawed universe.</p>
<p class="text">For black holes and dead ends,</p>
<p class="text">you will always be the beacon calling me home.</p>
<p class="text">My north star in a sky of falling ones.</p>
<p class="attribute">—<a id="_idTextAnchor165"></a>J. L. <span class="last-name">Wyman</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer146">
<p class="text">people spend so many nights</p>
<p class="text">running their fingers through their past.</p>
<p class="text">kinking their necks from looking back,</p>
<p class="text">trying to make fleeting moments last and last,</p>
<p class="text">longer than they’re written to.</p>
<p class="text">and all that while, the present is happening,</p>
<p class="text">morphing into past,</p>
<p class="text">and they’re missing the view. </p>
<p class="attribute">—<a id="_idTextAnchor166"></a>Cobie <span class="last-name">Kendra</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer147">
<p class="text">Some days I am larger than</p>
<p class="text">the flesh and bones that carry me.</p>
<p class="text">Other days I am smaller than</p>
<p class="text">the pores that lay within this skin.</p>
<p class="text">The figure that stands before you</p>
<p class="text">is not a testament of my true size.</p>
<p class="text">I am not to be judged by eyes alone.</p>
<p class="attribute">—<a id="_idTextAnchor167"></a><span>Raquel </span><span class="last-name">Franco</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer148">
<p class="poem-title">Insatiable</p>
<p class="text">If you knew</p>
<p class="text">How my mind would bend </p>
<p class="text">Like refracting light </p>
<p class="text">To include you</p>
<p class="text">In every thought,</p>
<p class="text">You would think me</p>
<p class="text">Tormented by your love.</p>
<p class="text t">If you knew </p>
<p class="text">How my fingers would separate,</p>
<p class="text">How they would reach out</p>
<p class="text">In the anticipation of </p>
<p class="text">Meeting your hand,</p>
<p class="text">You would think me</p>
<p class="text">Starved for your love.</p>
<p class="text t">If you knew how </p>
<p class="text">My eyes would dilate,</p>
<p class="text">How they would dance</p>
<p class="text">In their captivation,</p>
<p class="text">You would think me</p>
<p class="text">Beguiled by your love.</p>
<p class="text t">In truth,</p>
<p class="text">I am them all</p>
<p class="text">When it comes to you.</p>
<p class="text t">I am insatiable.</p>
<p class="text">I am insatiable</p>
<p class="text">I am insatiable.</p>
<p class="attribute">—<a id="_idTextAnchor168"></a>J. <span class="last-name">Bird</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer149">
<p class="text">Every blood vessel in these tired, red eyes</p>
<p class="text">yearns for the same thing</p>
<p class="text">that they have since the beginning.</p>
<p class="text">I still have hope that you can see that.</p>
<p class="text">Some people will call it delusion,</p>
<p class="text">and I’m okay with this.</p>
<p class="text">I hold that kind of expectation close</p>
<p class="text">because it’s the only way I know how to show loyalty—</p>
<p class="text">even when the odds are against me.</p>
<p class="attribute">—<a id="_idTextAnchor169"></a>Adan <span class="last-name">Portwood</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer150">
<p class="text">I don’t mind the mirror,</p>
<p class="text">I see hope in my reflection.</p>
<p class="attribute">—<a id="_idTextAnchor170"></a>M. <span class="last-name">FireChild</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer151">
<p class="text">you, with your bruised heart</p>
<p class="text">and defeated mind</p>
<p class="text">who chooses to rise</p>
<p class="text">with vulnerability and tenderness</p>
<p class="text">as your armor.</p>
<p class="text t">you, with the unbreakable will</p>
<p class="text">to overcome the hurt,</p>
<p class="text">put fear aside</p>
<p class="text">and still love.</p>
<p class="text t">you are the brave one.</p>
<p class="attribute">—<a id="_idTextAnchor171"></a>E.G. <span class="last-name">Cress</span></p>
<p class="text"> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer152">
<p class="text">i have been loved before but you</p>
<p class="text">can’t tell when you first look at me</p>
<p class="text t">most people don’t like to talk</p>
<p class="text">about the times that they’ve lost</p>
<p class="text t">but you’re my favorite story to tell at parties</p>
<p class="text t">if you asked me to describe the color hazel</p>
<p class="text">i would say it looks a lot like</p>
<p class="text">being left without an explanation </p>
<p class="text t">it was the middle of the night</p>
<p class="text">when you put my hands to my sides</p>
<p class="text">and told me i should stop breaking mirrors</p>
<p class="text t">and start practicing forgiveness. </p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor172"></a><span class="last-name">s.stepp</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer153">
<p class="text">Rejoice in suffering,</p>
<p class="text">and trust in what you cannot yet see clearly.</p>
<p class="text">Believe that the outcome is sweeter </p>
<p class="text">than honey in your mouth.</p>
<p class="text">Darling, don’t give up just yet. </p>
<p class="text">You’re almost there. You deserve it . . .</p>
<p class="text">deserve to live in peace and experience true happiness.</p>
<p class="text">That’s what you were made for.</p>
<p class="text">So for now, give it another go.</p>
<p class="text">Every new tomorrow, give it another go.</p>
<p class="attribute">—<a id="_idTextAnchor173"></a>Soeline <span class="last-name">Bosari</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer154">
<p class="text">Despite blackening skies </p>
<p class="text">and sullen clouds,</p>
<p class="text">I shall braid colors into my hair,</p>
<p class="text">Swallow sunsets for breakfast,</p>
<p class="text">And slide stars under my eyelids,</p>
<p class="text">For despite blackened skies</p>
<p class="text">and sullen clouds,</p>
<p class="text">I choose to see the rainbow. </p>
<p class="attribute">—<a id="_idTextAnchor174"></a>Sarah <span class="last-name">Janabi</span></p>
<p class="text"> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer155">
<p class="poem-title">Made for You</p>
<p class="text">I want to steal the roses off your lips</p>
<p class="text">and place them to your ear,</p>
<p class="text">so that you might stop and listen</p>
<p class="text">to your own blooming.</p>
<p class="text">You are divine</p>
<p class="text">and purposeful</p>
<p class="text">and real.</p>
<p class="text">So, angel, stop worrying.</p>
<p class="text">Keep your head up to those streaking, purple night skies.</p>
<p class="text">Somebody, somewhere was made for you.</p>
<p class="text">And when you wish upon the stars,</p>
<p class="text">know that your love is likely wishing upon them too.</p>
<p class="attribute">—<a id="_idTextAnchor175"></a><span>Michael Fawaz</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer156">
<p class="text">It’s a choice.</p>
<p class="text">It’s a choice to choose light,</p>
<p class="text">to forsake the weight of our scars,</p>
<p class="text">to weave pain into a tapestry of warmth</p>
<p class="text">for crueler days.</p>
<p class="text">The choice is terrifyingly full of promise.</p>
<p class="text">The choice is yours.</p>
<p class="text t">You</p>
<p class="text">are light.</p>
<p class="attribute">—<a id="_idTextAnchor176"></a>Brittin <span class="last-name">Oakman</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer157">
<p class="text">this clock didn’t seem to have numbers.</p>
<p class="text">time was neither moving nor still.</p>
<p class="text t">the sun rose and set from a horizon i once imagined,</p>
<p class="text">but never tried to look for.</p>
<p class="text t">i woke up last sunday with a fist full of suns in my hand</p>
<p class="text">and unspoken prayers huddled beside my pillow.</p>
<p class="text t">i’ve been asleep all along.</p>
<p class="attribute">—<a id="_idTextAnchor177"></a>israa <span class="last-name">ismaeil</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer158">
<p class="text">No shiny ball in the sky </p>
<p class="text">could ever compare to your spirit.</p>
<p class="text">Stars sputter, falter, and die.</p>
<p class="text">Too often, what we see is already gone.</p>
<p class="text">But you are a glorious, living, breathing soul.</p>
<p class="text">In your hands is the power to master fate.</p>
<p class="text">In your heart and your mind </p>
<p class="text">is the key to unlock any door</p>
<p class="text">no matter how it locks.</p>
<p class="text">Oh, beautiful human, </p>
<p class="text">I know that the dark days are heavy,</p>
<p class="text">but know that your purpose is to shine</p>
<p class="text">brighter than any rhinestone glittering across the sky.</p>
<p class="attribute">—<a id="_idTextAnchor178"></a>Dave <span class="last-name">Wise</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer159">
<p class="text">If anyone ever asks me,</p>
<p class="text">I won’t say I wasted any time</p>
<p class="text">while I indulged in building a life with you.</p>
<p class="text">And if they wonder why it came to an end,</p>
<p class="text">I’ll simply tell them how I was thankful</p>
<p class="text">enough to grow as a person alongside you.</p>
<p class="text">Even if our roots weren’t</p>
<p class="text">growing in the same direction,</p>
<p class="text">at least we grew.</p>
<p class="attribute">—<a id="_idTextAnchor179"></a><span>H. </span><span class="last-name">Christoffersen</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer160">
<p class="poem-title">Luring Wisdom</p>
<p class="text">Our egos yell at us</p>
<p class="text">to be impenetrable</p>
<p class="text">and dignified.</p>
<p class="text">Quiet it.</p>
<p class="text">Its roar scares away wisdom.</p>
<p class="text">Attract wisdom</p>
<p class="text">with the sap of</p>
<p class="text">weakness,</p>
<p class="text">vulnerability,</p>
<p class="text">transparency.</p>
<p class="text">There’s much sweetness</p>
<p class="text">in these things.</p>
<p class="text t">Wisdom begins</p>
<p class="text">when our quest</p>
<p class="text">for perfection</p>
<p class="text">ends.</p>
<p class="attribute">—<a id="_idTextAnchor180"></a>N. <span class="last-name">Wong</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer161">
<p class="text">He found me cradled </p>
<p class="text">In the embrace of mountains </p>
<p class="text">Nestled in my untainted nirvana.</p>
<p class="text">Feral, he calls me.</p>
<p class="text">“Wildflower,” he whispers against raw lips.</p>
<p class="text">He is the sun;</p>
<p class="text">A fixed point in my eternal horizon.</p>
<p class="text">I trace the flames </p>
<p class="text">That flicker beneath his skin,</p>
<p class="text">And coax them into mine.</p>
<p class="text">I am unapologetically his;</p>
<p class="text">Wholly and wildly contained.</p>
<p class="text">Who are you, all that I long for?</p>
<p class="text">What else is life but eternity in your presence?</p>
<p class="text">To be loved in the wild,</p>
<p class="text">To love ferociously— </p>
<p class="text">Two, no more.</p>
<p class="text">One; we are one.</p>
<p class="attribute">—<a id="_idTextAnchor181"></a>Marilyn <span class="last-name">Carp</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer162">
<p class="text">You, with the amaretto eyes</p>
<p class="text">and lips of refreshing candor;</p>
<p class="text">you, move like silent letters—</p>
<p class="text">the kind people trip over</p>
<p class="text">just trying to catch </p>
<p class="text">but still end up</p>
<p class="text">mispronouncing.</p>
<p class="text">You, are a reliquary of scars </p>
<p class="text">living in a world of your own,</p>
<p class="text">and I—</p>
<p class="text">I only hope</p>
<p class="text">I’m not just passing through.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor182"></a>Rachel <span class="last-name">Kay</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer163">
<p class="text">I collect my mistakes like little seeds of knowledge,</p>
<p class="text">plant them within the walls of my heart,</p>
<p class="text">and watch myself grow.</p>
<p class="attribute">—<a id="_idTextAnchor183"></a>Cindy <span class="last-name">Cherie</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer164">
<p class="text">The day I changed all my pain</p>
<p class="text">into something beautiful,</p>
<p class="text">I was reborn.</p>
<p class="text t">All my past turned into dust,</p>
<p class="text">and I understood I could start again</p>
<p class="text">with flowers in my hair.</p>
<p class="attribute">—<a id="_idTextAnchor184"></a>Ariadna <span class="last-name">Blanco</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer165">
<p class="text">When will we learn not to search for ourselves </p>
<p class="text">in other people,</p>
<p class="text">when the only place we can truly find ourselves </p>
<p class="text">is within?</p>
<p class="attribute">—<a id="_idTextAnchor185"></a>Emina <span class="last-name">Gašpar-Vrana</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer166">
<p class="text">She stands tall and proud,</p>
<p class="text">amongst perfect pieces,</p>
<p class="text">a broken thing.</p>
<p class="text">Behind the loud smiles,</p>
<p class="text">stifled tears she often blinks.</p>
<p class="text">Through metamorphosing pain,</p>
<p class="text">to this blurring hope</p>
<p class="text">she hopelessly clings:</p>
<p class="text">without the agony of change</p>
<p class="text">confined cocoons</p>
<p class="text">simply never get wings.</p>
<p class="text"> </p>
<p class="attribute">—<a id="_idTextAnchor186"></a><a id="_idTextAnchor187"></a>Nazish <span class="last-name">Akhtar</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer167">
<p class="text">Motivated by</p>
<p class="text">love or hate</p>
<p class="text">they’ll try to pull</p>
<p class="text">or push you away</p>
<p class="text">from who you are.</p>
<p class="text">Don’t break.</p>
<p class="text">Don’t even sway.</p>
<p class="text">With steadfast resolve</p>
<p class="text">occupy that space</p>
<p class="text">that belongs to you</p>
<p class="text">and only you.</p>
<p class="text">They can join you there</p>
<p class="text">or they can run away.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor188"></a><a id="_idTextAnchor189"></a>J. Warren <span class="last-name">Welch</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer168">
<p class="poem-title">Stay From the Path</p>
<p class="text">The greatest tragedy in life </p>
<p class="text">is to believe yourself a failure </p>
<p class="text">because you do not follow the path </p>
<p class="text">that society demands you march.</p>
<p class="attribute">—<a id="_idTextAnchor190"></a>Daniel <span class="last-name">Walsh</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer169">
<p class="text">And within her wild moments</p>
<p class="text">she thought less about him</p>
<p class="text">and more about loving herself,</p>
<p class="text">her life,</p>
<p class="text">her freedom.</p>
<p class="attribute">—<a id="_idTextAnchor191"></a>Yasmin A. <span class="last-name">Gomez</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer170">
<p class="text">And so I wander</p>
<p class="text">In my once-cherished paradise,</p>
<p class="text">With memories that both warm</p>
<p class="text">And haunt me.</p>
<p class="text">I wander, </p>
<p class="text">With nothing but my broken thoughts.</p>
<p class="text">Waiting for dawn,</p>
<p class="text">With fingers outstretched for sunlight.</p>
<p class="text">His voice carries on the wind,</p>
<p class="text">Accompanying the promise </p>
<p class="text">Of a much-welcomed thunderstorm.</p>
<p class="text">Love itself had not wronged me.</p>
<p class="text">It gave me hope,</p>
<p class="text">And reminded me; </p>
<p class="text">Love in its entirety </p>
<p class="text">Would always</p>
<p class="text">Push me ever forward.</p>
<p class="attribute">—<a id="_idTextAnchor192"></a>Marilyn <span class="last-name">Carp</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer171">
<p class="text">If life is the religion, then children are truly the martyrs.</p>
<p class="text">The “old and wise” hammer in the nails</p>
<p class="text">with every passing year</p>
<p class="text">until they suffer just as their fathers did,</p>
<p class="text">until they are bitter and cold</p>
<p class="text">like the timeless ones before them.</p>
<p class="text t">If only we can keep them from that.</p>
<p class="text">If only we can plant trees instead of briars.</p>
<p class="text">If only we can allow them to grow to touch the sun</p>
<p class="text">rather than stunt them in their spring.</p>
<p class="attribute">—<a id="_idTextAnchor193"></a>Dave <span class="last-name">Wise</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer172">
<p class="text">There are times when emotions can be flooding.</p>
<p class="text">The mind becomes lathered in beauty and pain,</p>
<p class="text">excitement and sorrow.</p>
<p class="text t">This is what comes</p>
<p class="text">when windows close and doors open.</p>
<p class="text">The darkness throws punches,</p>
<p class="text">but the light will overcome.</p>
<p class="attribute">—<a id="_idTextAnchor194"></a><span>Raquel </span><span class="last-name">Franco</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer173">
<p class="text">We watch the ocean’s whispered winds</p>
<p class="text">buffet the seagulls way up high,</p>
<p class="text">and we wonder why we can’t learn to love life’s lessons,</p>
<p class="text">which push and pull us along</p>
<p class="text">in quite the same way these birds love</p>
<p class="text">the wind.</p>
<p class="attribute">—<a id="_idTextAnchor195"></a>Rose <span class="last-name">C.L.</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer174">
<p class="text">Fall has always been my favorite time,</p>
<p class="text">watching the trees outside my window.</p>
<p class="text">I see myself in the leaves.</p>
<p class="text t">How they seem to be lost,</p>
<p class="text">scattered,</p>
<p class="text">and dying only to be reborn,</p>
<p class="text">new and green.</p>
<p class="text t">How the trees lose their color</p>
<p class="text">only to gain new and vibrant shades.</p>
<p class="text t">Change is always coming,</p>
<p class="text">and it is nothing to be feared.</p>
<p class="text">Dead leaves are not the end of a tree,</p>
<p class="text">they’re just another beginning.</p>
<p class="text t">So, I watch the trees outside my window,</p>
<p class="text">and I hold on.</p>
<p class="attribute">—<a id="_idTextAnchor196"></a>Michael <span class="last-name">Layao</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer175">
<div><img alt="blank" src="image/blank.gif"/></div>
<p class="small-caps t2 _idGenParaOverride-1"><span class="CharOverride-3"><a id="_idTextAnchor197"></a>Look Homeward, Angel</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer176">
<p class="text">i do not want to wear the world on the back</p>
<p class="text">of my hands because then you might believe</p>
<p class="text">i know everything and maybe i would, too.</p>
<p class="text">instead, i will take time learning how to read </p>
<p class="text">and discover you in pieces, because so often</p>
<p class="text">when we get everything all at once</p>
<p class="text">it is taken away just as fast.</p>
<p class="text t">what we build could be a table for two, or four, or</p>
<p class="text">maybe even nothing, but the thing that matters most</p>
<p class="text">is that our palms are not left empty.</p>
<p class="text">when they are filled with every layer </p>
<p class="text">we have lived and loved,</p>
<p class="text">our arms will know it was worth the weight.</p>
<p class="text t">i will not walk with fists at my side</p>
<p class="text">because when my hands are out and open</p>
<p class="text">it is easier to catch the things that may fall,</p>
<p class="text t">like stars,</p>
<p class="text">the rain, </p>
<p class="text">and you.</p>
<p class="attribute">—<a id="_idTextAnchor198"></a><span class="last-name">Wilder</span><span> </span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer177">
<p class="text">we wear our histories</p>
<p class="text">heavy on our backs.</p>
<p class="text t">it’s time i unpacked</p>
<p class="text">my spine,</p>
<p class="text t">stood up straight,</p>
<p class="text">and moved on.</p>
<p class="attribute">—<a id="_idTextAnchor199"></a>Jess <span class="last-name">Adams</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer178">
<p class="text">We are our own masterpiece,</p>
<p class="text">our scars painted like graffiti</p>
<p class="text">on the skeleton that carries us.</p>
<p class="attribute">—<a id="_idTextAnchor200"></a>M. <span class="last-name">FireChild</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer179">
<p class="poem-title">Rock Solid</p>
<p class="text">Life weighs one thousand pounds,</p>
<p class="text">but it feels like more.</p>
<p class="text">And while my elbows break and my knees buckle,</p>
<p class="text">I wonder how much more pressure I can take</p>
<p class="text">before I crack</p>
<p class="text">or turn into a diamond.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor201"></a>Gabriel <span class="last-name">Sage</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer180">
<p class="poem-title">Faerytale</p>
<p class="text">As the years elapsed,</p>
<p class="text">her pain became her happiness,</p>
<p class="text">her suffering her strength,</p>
<p class="text">and her scars her wisdom.</p>
<p class="text t">Her passion became incorrigible</p>
<p class="text">and she burned for so much more</p>
<p class="text">than to merely subsist.</p>
<p class="text t">The echoing silence that once screamed her name</p>
<p class="text">now beckoned her stay</p>
<p class="text">as she began to crave existence</p>
<p class="text">and yearn for nothing less than the remarkable.</p>
<p class="text t">She was reborn—brutally and unapologetically—</p>
<p class="text">and she no longer had need of a hero,</p>
<p class="text">for she had become her own savior</p>
<p class="text">in the creases of her mind—</p>
<p class="text">a heroine in her own right.</p>
<p class="attribute">—<a id="_idTextAnchor202"></a><span>Becca </span><span class="last-name">Lee</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer181">
<p class="text">Wisdom can’t be bought.</p>
<p class="text">It must be found.</p>
<p class="text">It must be earned.</p>
<p class="text">It’s the beautiful cuts</p>
<p class="text">on our soles</p>
<p class="text">from where our feet meet the earth.</p>
<p class="text">The blood we bleed,</p>
<p class="text">those scarlet footsteps that we leave,</p>
<p class="text">it’s the way that we must lead.</p>
<p class="text">That’s the way we must lead.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor203"></a>Jess <span class="last-name">Adams</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer182">
<p class="text">The corrosion I feel in my bones as the years creep by</p>
<p class="text">comforts me in quite a peculiar way.</p>
<p class="text">My beginning gives way to the closing chapters,</p>
<p class="text">and there’s something exciting about ending,</p>
<p class="text">whether happy or otherwise . . .</p>
<p class="text">for to end </p>
<p class="text">means to have the opportunity of beginning anew</p>
<p class="text">down a different avenue.</p>
<p class="text">I’m aware that one day the final ending will be upon me,</p>
<p class="text">but even then I anticipate a future of forever.</p>
<p class="attribute">—<a id="_idTextAnchor204"></a>Rose <span class="last-name">C.L.</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer183">
<p class="poem-title">Hatch</p>
<p class="text">This is not your heart breaking, my darling.</p>
<p class="text">This is your heart hatching,</p>
<p class="text">shedding the shell of who you once were.</p>
<p class="text">This is your rebirth.</p>
<p class="attribute">— <a id="_idTextAnchor205"></a>T. <span class="last-name">Weiss</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer184">
<p class="text">Like a butterfly testing its wings for the first time,</p>
<p class="text">she prepares herself for the initial flight of her life.</p>
<p class="text">In becoming who she is, she had to shed who she was</p>
<p class="text">for the betterment of her spirit.</p>
<p class="text t">Now she’s an adventure waiting to happen,</p>
<p class="text">and the stars are now home.</p>
<p class="attribute">—<a id="_idTextAnchor206"></a>Zachry K. <span class="last-name">Douglas</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer185">
<p class="text">Bend the ladders</p>
<p class="text">of your ribs.</p>
<p class="text">Release your heart</p>
<p class="text">from the inside out.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor207"></a><span>Raquel </span><span class="last-name">Franco</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer186">
<p class="poem-title">Evanescence</p>
<p class="text">Scarlet hues streaked the horizon</p>
<p class="text">as the girl in the red dress</p>
<p class="text">faded from sight.</p>
<p class="text t">“Wait!” he called,</p>
<p class="text">clutching nothing but a glass slipper</p>
<p class="text">to remember her by.</p>
<p class="text t">“How shall I find you?”</p>
<p class="text t">His reply came as a distant song,</p>
<p class="text">drifting in the wind,</p>
<p class="text">painting picture-perfect evanescence</p>
<p class="text">across the midnight sky.</p>
<p class="text t">“When I find myself, I’ll let you know.”</p>
<p class="attribute">—<a id="_idTextAnchor208"></a>Cindy <span class="last-name">Cherie</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer187">
<p class="text">Pain, in all its madness, is a potent and </p>
<p class="text">relentless ally. Don’t look at it with fear.</p>
<p class="text">Consider it the soil and you are a sprouting </p>
<p class="text">tree. Consider it wind and you are a</p>
<p class="text">potential hurricane. With pain, you’ll grow</p>
<p class="text">stronger and stronger, every time it hurts.</p>
<p class="attribute _idGenParaOverride-1">—<span class="last-name"><a id="_idTextAnchor209"></a><a id="_idTextAnchor210"></a>a.r.lucas</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer188">
<p class="text">learn to love the moments</p>
<p class="text">between destinations,</p>
<p class="text">the quiet moments with yourself,</p>
<p class="text">the slow moments when life</p>
<p class="text">seems to be waiting to give you</p>
<p class="text">your next instruction;</p>
<p class="text t">trust that you’re preparing</p>
<p class="text">for the next stage of your life,</p>
<p class="text">and be ready when the next door opens,</p>
<p class="text">and it’s time to walk inside. </p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor211"></a><a id="_idTextAnchor212"></a>Mark <span class="last-name">Anthony</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer189">
<p class="poem-title">Spring in Every Season</p>
<p class="text">Sometimes the simple things take me by surprise.</p>
<p class="text t">The Reveille</p>
<p class="text">the sparrow sings.</p>
<p class="text">Our child nursing.</p>
<p class="text">Hazel fractals in your eyes.</p>
<p class="text t">The joys of spring, of new life, of rebirth!</p>
<p class="text t">The seasons may change with their own timing,</p>
<p class="text">but in my mind I’ll always find the simple surprises</p>
<p class="text">spring is known to bring.</p>
<p class="attribute">—<a id="_idTextAnchor213"></a>C. <span class="last-name">Noel</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer190">
<p class="poem-title">Gratefulness</p>
<p class="text">The fullness of one breath,</p>
<p class="text">fully lived.</p>
<p class="attribute">—<a id="_idTextAnchor214"></a><a id="_idTextAnchor215"></a><span>Fiorella </span><span class="last-name">Giordano</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer191">
<p class="text">The facade of bravado falls</p>
<p class="text">with my clothing to the floor,</p>
<p class="text">with my makeup down the drain,</p>
<p class="text">with the cold water</p>
<p class="text">every night before I sleep.</p>
<p class="text t">I am stripped naked of my masks and pride—</p>
<p class="text">all flaws exposed, even the ones I keep inside.</p>
<p class="text t">The mirror reveals them to my searching eyes.</p>
<p class="text">Everyone should stand naked daily</p>
<p class="text">because we are human, we are broken,</p>
<p class="text">and we are beautiful.</p>
<p class="attribute">—<a id="_idTextAnchor216"></a>Rose <span class="last-name">C.L.</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer192">
<p class="text">I let myself burn deep within my bones.</p>
<p class="text">Nothing remains but ashes.</p>
<p class="text">I am waiting for the smoke to settle,</p>
<p class="text">and once the skies clear,</p>
<p class="text">I will emerge from the smoldering rubble</p>
<p class="text">reborn,</p>
<p class="text">free of the chains with which I once bound myself,</p>
<p class="text">a sinful distraction to pass the time.</p>
<p class="text">Now I am naked, basking in my truth.</p>
<p class="text">All that’s left of the past are my stories—</p>
<p class="text">words I once whispered</p>
<p class="text">with hopes that someone would hear me.</p>
<p class="text">I was lost for so long in a world promising me love.</p>
<p class="text">I am leaving it behind to discover the fire</p>
<p class="text">igniting within me.</p>
<p class="attribute">—<a id="_idTextAnchor217"></a><span>Jessica </span><span class="last-name">Michelle</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer193">
<p class="text">I am a strange and wild thing.</p>
<p class="text">I dance with no music and talk to silence,</p>
<p class="text">and I regret nothing.</p>
<p class="attribute">—<a id="_idTextAnchor218"></a>Ariadna <span class="last-name">Blanco</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer194">
<p class="poem-title">Women Within</p>
<p class="text">Every experience introduces me</p>
<p class="text">to another woman, and all of these women</p>
<p class="text">wear my face—</p>
<p class="text">they are all mine.</p>
<p class="text t">So, knowing you</p>
<p class="text">was not a waste of time.</p>
<p class="text">Because of you, I met a very strong me.</p>
<p class="text">She came into my body and</p>
<p class="text">taught me</p>
<p class="text">to be kind in the face of cruelty,</p>
<p class="text">to forgive the undeserving,</p>
<p class="text">to sacrifice in the name of hope,</p>
<p class="text">and persist when met with defiance.</p>
<p class="text t">This woman taught me suppleness</p>
<p class="text">in the midst of thorniness,</p>
<p class="text">and I love her for this.</p>
<p class="text">You’re gone now, and a new woman</p>
<p class="text">wearing my face taps me on the shoulder.</p>
<p class="text">She is just as strong as the last,</p>
<p class="text">but she is wise.</p>
<p class="text t">Again I open my ribs and wave her in.</p>
<p class="text">From her, I’m learning</p>
<p class="text">about my worth and my boundaries.</p>
<p class="text">But most importantly, she is teaching me</p>
<p class="text">to always heed any woman</p>
<p class="text">within me if she tells me</p>
<p class="text">something is amiss.</p>
<p class="attribute">—<a id="_idTextAnchor219"></a>N. <span class="last-name">Wong</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer195">
<p class="text">Allow yourself to experience the beauty</p>
<p class="text">of forgiveness and the grace of change.</p>
<p class="text">Allow yourself to move on, to let go.</p>
<p class="attribute">—<a id="_idTextAnchor220"></a><span class="last-name">Paradox</span><span class="last-name"> </span><span class="last-name CharOverride-10">&amp;</span><span class="last-name"> </span><span class="last-name">Metaphors</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer196">
<p class="text">I’ve fallen in love with the absence of your heartbeat.</p>
<p class="text">The silence is a peaceful reminder that I deserve more.</p>
<p class="attribute">—<a id="_idTextAnchor221"></a><span>H. </span><span class="last-name">Christoffersen</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer197">
<p class="text">He sends me love songs</p>
<p class="text">In my sleep</p>
<p class="text">He lies awake</p>
<p class="text">But dreams of me.</p>
<p class="text">The pain of absence </p>
<p class="text">Lodged so deep </p>
<p class="text">We feel the ache </p>
<p class="text">Concurrently.</p>
<p class="text">And while he sleeps </p>
<p class="text">Again I rise</p>
<p class="text">And face the morning</p>
<p class="text">On my own</p>
<p class="text">A tender longing for the jones</p>
<p class="text">My heart’s injected</p>
<p class="text">To the bone.</p>
<p class="text">And while he breathes </p>
<p class="text">I find my way</p>
<p class="text">Hold fast to </p>
<p class="text">Every curve and bend </p>
<p class="text">So he can breathe </p>
<p class="text">Into my lungs </p>
<p class="text">And one plus one</p>
<p class="text">Is two again. </p>
<p class="attribute">—<a id="_idTextAnchor222"></a>r.z. <span class="last-name">joyce</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer198">
<p class="text">Sometimes all you can do is laugh,</p>
<p class="text">empty your pockets and hands,</p>
<p class="text">run into the street giddy like a madman,</p>
<p class="text">and throw a finger to the world.</p>
<p class="attribute">—<a id="_idTextAnchor223"></a>A.R. <span class="last-name">Asher</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer199">
<p class="text">I scoured the earth incessantly,</p>
<p class="text">to find the valiant love I craved.</p>
<p class="text">I deviated from my path,</p>
<p class="text">to the unknown that I braved.</p>
<p class="text">I seek a love that grips me,</p>
<p class="text">through every waking night,</p>
<p class="text">and amends all my wrongs,</p>
<p class="text">til they eventually feel right.</p>
<p class="text">A love that will invest,</p>
<p class="text">in my ever-changing dreams,</p>
<p class="text">and that will calm the panic attacks,</p>
<p class="text">of my many silent screams.</p>
<p class="text">A love that will not hesitate,</p>
<p class="text">to haul my heavy pain,</p>
<p class="text">and one I can surely trust,</p>
<p class="text">to never leave or wane.</p>
<p class="text">I reflected upon the path,</p>
<p class="text">carved throughout my solo quest,</p>
<p class="text">and the wounds I have healed,</p>
<p class="text">from the strength of my own press;</p>
<p class="text">the obstacles I conquered,</p>
<p class="text">my persistence advanced me through;</p>
<p class="text">and determination drove me,</p>
<p class="text">down a road I never knew.</p>
<p class="text">When my conviction finally struck me,</p>
<p class="text">my search needn’t be prolonged,</p>
<p class="text">as the valiant love I was looking for,</p>
<p class="text">lived inside me all along.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor224"></a><span>Vivi </span><span class="last-name">Dale</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer200">
<p class="text">I found a home in the arms of strangers.</p>
<p class="text">We dance with bare feet,</p>
<p class="text">Chest-to-chest </p>
<p class="text">Under the light of the moon.</p>
<p class="text">Laughing away our sanity</p>
<p class="text">And howling at the moon.</p>
<p class="text">Wildlings,</p>
<p class="text">Content with our lack of direction.</p>
<p class="text">And now, here we lie;</p>
<p class="text">Beneath the skin of stars,</p>
<p class="text">Tasting the stories that fall from their lips.</p>
<p class="text">Restless oceans surround us here,</p>
<p class="text">As we inhale our dreams.</p>
<p class="text">Pain, with nothing to feed on, does not thrive here.</p>
<p class="text">And we know;</p>
<p class="text">We are finally home.</p>
<p class="attribute">—<a id="_idTextAnchor225"></a><a id="_idTextAnchor226"></a>Marilyn <span class="last-name">Carp</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer201">
<p class="text">I run my fingers along</p>
<p class="text">the string of a guitar </p>
<p class="text">I cannot play—the sound </p>
<p class="text">could be beautiful, if I</p>
<p class="text">strummed it differently.</p>
<p class="text t">I think maybe I have liked</p>
<p class="text">the things that are just</p>
<p class="text">out of reach—because</p>
<p class="text">to yearn is different than</p>
<p class="text">to grieve. </p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor227"></a><a id="_idTextAnchor228"></a>Kristen Laura <span class="last-name">Costa</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer202">
<p class="text">Sometimes we become addicted to our trauma.</p>
<p class="text">It both weakens and strengthens us,</p>
<p class="text">but we must let go.</p>
<p class="text">It is liberating—but also a bit sad—</p>
<p class="text">to relinquish the power it’s given us</p>
<p class="text">to make excuses, to cry, to retreat, and to lash out. </p>
<p class="text t">It’s become a part of us.</p>
<p class="text t">Let go of the pain so you may regain your true strength.</p>
<p class="attribute">—<a id="_idTextAnchor229"></a>Allison <span class="last-name">Theresa</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer203">
<p class="text">In the wake of you I saw hell.</p>
<p class="text">I traveled seven circles deep inside myself.</p>
<p class="text">It wasn’t until the bottom,</p>
<p class="text">the very depths,</p>
<p class="text">the breaking point,</p>
<p class="text">that I found traces of life.</p>
<p class="text">Littered on the ground</p>
<p class="text">were fragments of who I used to be</p>
<p class="text">and reminders of</p>
<p class="text">who I could be again.</p>
<p class="text">I collected the pieces in my tired hands</p>
<p class="text">and counted;</p>
<p class="text">not enough to live,</p>
<p class="text">no,</p>
<p class="text">but enough to start my resurrection.</p>
<p class="text">I needed to learn how to live again</p>
<p class="text">and losing everything</p>
<p class="text">was my greatest lesson.</p>
<p class="attribute">—<a id="_idTextAnchor230"></a>Michael <span class="last-name">Layao</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer204">
<p class="text">Dearest,</p>
<p class="text">when life’s trials seem to overwhelm you</p>
<p class="text">and peace is far from your heart,</p>
<p class="text">when your soul becomes too weary</p>
<p class="text">and your mind is drowning in burdensome thoughts,</p>
<p class="text">please know that an anchor of strength</p>
<p class="text">can be found in the arms of love.</p>
<p class="attribute">—<a id="_idTextAnchor231"></a>Soeline <span class="last-name">Bosari</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer205">
<p class="text">No single soul walking this gritty earth</p>
<p class="text">is ever meant to remain seamless.</p>
<p class="text">Our edges, flaws, indications, and interruptions</p>
<p class="text">free us from being a carbon copy.</p>
<p class="text">That’s the purest freedom of all.</p>
<p class="attribute">—<a id="_idTextAnchor232"></a>Kate <span class="last-name">Foster</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer206">
<p class="poem-title">Silence</p>
<p class="text">It’s really quiet sometimes.</p>
<p class="text">I need it, the silence.</p>
<p class="text">At times I need to be alone with it.</p>
<p class="text">When it is all too real, when I am</p>
<p class="text">overwhelmed by life, I seek it out.</p>
<p class="text t">I don’t know if it helps, </p>
<p class="text">but it is there, and for a time </p>
<p class="text">that is all that matters.</p>
<p class="attribute">—<a id="_idTextAnchor233"></a>Daniel <span class="last-name">Walsh</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer207">
<p class="text">A crushed reed.</p>
<p class="text">A damaged petal.</p>
<p class="text">My garden is a lost secret and a lost cause to most.</p>
<p class="text">But not to you.</p>
<p class="text">You see vibrancy and life in what others dismissed</p>
<p class="text">as sparse and meager.</p>
<p class="text">With your masterful skills,</p>
<p class="text">you gently pull the weeds from my red, beating heart.</p>
<p class="text">You toil in the sun and work my soul</p>
<p class="text">with the tenderness of an experienced gardener.</p>
<p class="text">You grow from me a sophisticated vine.</p>
<p class="text">A willow tree.</p>
<p class="text">An olive branch.</p>
<p class="text">Now paradise sprouts amongst soil </p>
<p class="text">that is rich with forgiveness.</p>
<p class="text">Let mercy rain down on me.</p>
<p class="text">Let your love water my recovery.</p>
<p class="attribute">—<a id="_idTextAnchor234"></a>J. L. <span class="last-name">Wyman</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer208">
<p class="poem-title">Ethereal</p>
<p class="text">Too often are we afraid to fall,</p>
<p class="text">mistaking mortality as our curse.</p>
<p class="text t">My dear, when will you learn that to bleed</p>
<p class="text">is the greatest of gifts?</p>
<p class="text t">For humanity knows the bounds of life and loss</p>
<p class="text">which privileges us to love as no angel,</p>
<p class="text">hallowed or forsaken, may know.</p>
<p class="text t">So before you renounce the fragile flesh upon you,</p>
<p class="text">discover the truth in the blood </p>
<p class="text">licked from your wounds . . .</p>
<p class="text">for the most vital lessons are learned in the falls,</p>
<p class="text">and your greatest wisdom is born from the depths</p>
<p class="text">of your surmounted despair.</p>
<p class="text t">Your greatest strength lies in welcome imperfections.</p>
<p class="attribute">—<a id="_idTextAnchor235"></a><span>Becca </span><span class="last-name">Lee</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer209">
<p class="text">as drowning turns to life</p>
<p class="text">as songs turn to breath</p>
<p class="text">waves no longer pummel</p>
<p class="text">another mermaid cheats death</p>
<p class="text t">maybe the magic is all we need</p>
<p class="text">to live without hindrance </p>
<p class="text">of what normality sees. </p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor236"></a>C. <span class="last-name">Churchill</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer210">
<p class="text">She is a magnificent representation of </p>
<p class="text">winning wars with only hope holding her spirit together</p>
<p class="text">and determination painted on her lips.</p>
<p class="attribute">—<a id="_idTextAnchor237"></a>Kayil <span class="last-name">Crow</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer211">
<p class="text">When we’re surrounded by chaos, we find ways to</p>
<p class="text">make peace against the turbulence once we find</p>
<p class="text">ourselves between life’s hectic pace,</p>
<p class="text">in the pockets of stillness.</p>
<p class="text">It’s in our nature to revel in chaos, the frequencies</p>
<p class="text">of agitation still resonate within us no matter how</p>
<p class="text">much we think we’re above it. We’re part of it.</p>
<p class="text">I’ve learned some of my deepest lessons immersed</p>
<p class="text">in the chaos. But it’s also worn me down a few</p>
<p class="text">times. So my creativity is sparked by what lives</p>
<p class="text">between the chaos and peace. Both inside and out.</p>
<p class="attribute">—<a id="_idTextAnchor238"></a><span class="last-name"><a id="_idTextAnchor239"></a>d</span><span class="last-name">á</span><span class="last-name">eizm</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer212">
<p class="text">What are peaks and valleys when you</p>
<p class="text">have someone who kisses your</p>
<p class="text">forehead at night and holds your hand</p>
<p class="text">in the car?</p>
<p class="attribute">—<a id="_idTextAnchor240"></a><a id="_idTextAnchor241"></a>Ryan <span class="last-name">Hennessy</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer213">
<p class="text">If you have</p>
<p class="text">no desire</p>
<p class="text">to get back up,</p>
<p class="text">then there was</p>
<p class="text">no point in</p>
<p class="text">being</p>
<p class="text">knocked down.</p>
<p class="attribute">—<a id="_idTextAnchor242"></a>Andrew <span class="last-name">Durst</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer214">
<p class="text">My scars are sketching</p>
<p class="text">the bridge to my strength</p>
<p class="text">as my courage leads the way.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor243"></a>M. <span class="last-name">FireChild</span> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer215">
<p class="text">we lie tonight</p>
<p class="text">as we have lain</p>
<p class="text">with any lover,</p>
<p class="text">who has ever</p>
<p class="text">proved us a phoenix.</p>
<p class="text t">hopes undressed; we are carried</p>
<p class="text">in the palm</p>
<p class="text">of a new year’s tender hand.</p>
<p class="text t">may it never strike in malice.</p>
<p class="text t">it is tonight, in hope</p>
<p class="text">and in love,</p>
<p class="text">that we are reborn.</p>
<p class="attribute">—<a id="_idTextAnchor244"></a>Jess <span class="last-name">Adams</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer216">
<p class="text">I did not rise because I am strong.</p>
<p class="text">I rose because I have a purpose</p>
<p class="text">stronger than all of my weaknesses.</p>
<p class="attribute">—<a id="_idTextAnchor245"></a>Dru <span class="last-name">Anthony</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer217">
<p class="text">Love will endure the silence,</p>
<p class="text">but you have to be willing to scream.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor246"></a><span>Vivi </span><span class="last-name">Dale</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer218">
<p class="text">I stood there, waiting for proof—</p>
<p class="text">proof that I could survive,</p>
<p class="text">proof that I would resurface from the rubble</p>
<p class="text">beneath which I buried myself.</p>
<p class="text">I was waiting for a sign from the heavens—</p>
<p class="text">a sign that I would find the strength </p>
<p class="text">to get through this hell.</p>
<p class="text">And through all the time I spent waiting,</p>
<p class="text">I made it.</p>
<p class="attribute">—<a id="_idTextAnchor247"></a><span>Jessica </span><span class="last-name">Michelle</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer219">
<p class="text">She grew tired of chasing storms,</p>
<p class="text">so she became one.</p>
<p class="text">And now they chase after her.</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor248"></a>Adrian Michael <span class="last-name">Green</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer220">
<p class="text">We are a restless bunch</p>
<p class="text">born of the same stardust as royalty.</p>
<p class="text">We are all noble creatures of infinite light,</p>
<p class="text">yet we have buried our inheritance in mud bricks</p>
<p class="text">that now rise up around every corner of our hearts.</p>
<p class="text t">In this land of broken dreams,</p>
<p class="text">I will no longer stand watchman </p>
<p class="text">to an empty tower.</p>
<p class="text">I will use my hands to deconstruct</p>
<p class="text">all that my mistakes </p>
<p class="text">and my regrets have built around me.</p>
<p class="text t">I will take back my inheritance, </p>
<p class="text">hidden in the bricks,</p>
<p class="text">and when I have carved a hole in the wall</p>
<p class="text">I will step out into the world of tomorrow,</p>
<p class="text">a blank canvas stitched in light and confidence.</p>
<p class="text t">We deconstruct our walls </p>
<p class="text">as we learn to love ourselves.</p>
<p class="attribute">—<a id="_idTextAnchor249"></a><span>Analog </span><span class="last-name">de Lēon</span><span> </span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer221">
<p class="text">I keep reaching for something </p>
<p class="text">Too tall for me</p>
<p class="text">Damn these roots</p>
<p class="text">That hold me here</p>
<p class="text">Digging into the ground</p>
<p class="text">The soil</p>
<p class="text">The black of your skin</p>
<p class="text">The promises you wouldn’t give </p>
<p class="text">Keeping me on earth</p>
<p class="text">When I was made for more</p>
<p class="text">When I was made</p>
<p class="text">For a higher love</p>
<p class="attribute _idGenParaOverride-1">—<a id="_idTextAnchor250"></a>Heidi <span class="last-name">Kidd</span> </p>
</div>
<div class="Basic-Text-Frame" id="_idContainer222">
<p class="text">She undresses her wounds,</p>
<p class="text">stripping to vulnerability,</p>
<p class="text">leaving behind anything</p>
<p class="text">that does not lift her soul.</p>
<p class="attribute">—<a id="_idTextAnchor251"></a>Simi <span class="last-name">Fromen</span></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer223">
<p class="text">Atop a mountain in the desert,</p>
<p class="text">the same sun, that every soul</p>
<p class="text">who ever lived beheld,</p>
<p class="text">warms the still air of a new morning.</p>
<p class="text">Light vibrates everything </p>
<p class="text">underneath a cloudless sky,</p>
<p class="text">while high desert winds pick up</p>
<p class="text">and push the warm air,</p>
<p class="text">ripe with energy, </p>
<p class="text">toward the flat expanse below.</p>
<p class="text">I, cradled in the vastness,</p>
<p class="text">absorb the charged gust,</p>
<p class="text">breathe the boiling breeze into my lungs,</p>
<p class="text">and hold the universe inside my breath.</p>
<p class="attribute">—<a id="_idTextAnchor252"></a>Gabriel <span class="last-name">Sage</span></p>
</div>
<div class="_idGenObjectLayout-1 pb">
<p class="t3"> </p>
<img alt="lost poets symbol" class="_idGenObjectAttribute-1" src="image/lp.jpg" style="width: 30%;"/>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer235">
<p class="small-caps ParaOverride-4"><span class="CharOverride-3"><a id="_idTextAnchor253"></a>About the Authors</span></p>
<p class="text"><span class="CharOverride-2">Crown Anthology</span> is a collection by Lost Poets featuring over one hundred diverse voices from around the world, curated to be a light in the wild dark, illuminating the crown that exists  in everyone.</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer237">
<p class="small-caps ParaOverride-4"><span class="CharOverride-3"><a id="_idTextAnchor254"></a>An Open Letter to the Lost</span></p>
<p class="text ParaOverride-10"><span class="CharOverride-2">O’Lost,</span></p>
<p class="text ParaOverride-10 t">We are a lost generation of analog people living in a digital age, where truth has gone the alternative way of rumor, social good has become secondary to economic gain, beauty is defined by Photoshop, and prejudice has become the dominant voice of our generation. The silicon age of information has smothered us into paralysis, stolen our privacy, and conditioned us to line up to be the first to buy Big Brother. </p>
<p class="text ParaOverride-10 t">The world has never needed voices of resistance more, voices of hope and self-love, of fresh water and empowerment. We desperately need more Bob Dylan and Maya Angelou style voices. Join us and commit your art to the resistance. Great  art has purpose . . . </p>
<p class="text ParaOverride-10 t">Sincerely from the planet Earth,</p>
<p class="text t">Analog de Lēon</p>
<p class="attribute n">A Moniker of Chris Purifoy</p>
</div>
<div class="_idGenObjectStyleOverride-1" epub:type="toc" id="_idContainer238">
<p class="small-caps ParaOverride-4"><span class="CharOverride-3"><a id="_idTextAnchor255"></a>Artist Index</span></p>
</div>
<table style="width: 99%; cellspacing: 5px; cellpadding: 5px;">
<tbody>
<tr>
<th scope="col"> </th>
<th class="l" scope="col"><img alt="" src="image/glyph-logo_May2016.png" style="width: 50%;"/></th>
</tr>
<tr>
<td><p class="index-text"><span class="last-name CharOverride-11">a.c.sparks</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor112"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/a.c.sparks/" target="_blank">@a.c.sparks</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Adan </span><span class="last-name CharOverride-11">Portwood </span><a href="#/Crown_Anthologies_epub#_idTextAnchor092"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor169"><span class="Character-Style-1 CharOverride-12">2</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/adanportwood" target="_blank">@adanportwood</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Adrian Michael </span><span class="last-name CharOverride-11">Green </span><a href="#/Crown_Anthologies_epub#_idTextAnchor097"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor137"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor146"><span class="Character-Style-1 CharOverride-12">3</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor248"><span class="Character-Style-1 CharOverride-12">4</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/adrianmichaelgreen" target="_blank">@adrianmichaelgreen</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor095"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="last-name CharOverride-11">A.D.Woods</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor096"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/a.d.woods" target="_blank">@a.d.woods</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor134"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="last-name CharOverride-11">A.Kelman</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor134"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/akscrolls" target="_blank">@akscrolls</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Alice </span><span class="last-name CharOverride-11">Morrison </span><a href="#/Crown_Anthologies_epub#_idTextAnchor013"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/alicemorrison514" target="_blank">@alicemorrison514</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Alison </span><span class="last-name CharOverride-11">Malee </span><a href="#/Crown_Anthologies_epub#_idTextAnchor016"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor060"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor101"><span class="Character-Style-1 CharOverride-12">3</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/alison.malee" target="_blank">@alison.malee</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor019"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Allison </span><span class="last-name CharOverride-11">Theresa</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor019"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor074"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor109"><span class="Character-Style-1 CharOverride-12">3</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor135"><span class="Character-Style-1 CharOverride-12">4</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor229"><span class="Character-Style-1 CharOverride-12">5</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/_allisontheresa_" target="_blank">@_allisontheresa_</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor073"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Allison </span><span class="last-name CharOverride-11">Theresa</span><span class="CharOverride-11"> and Gabriel </span><span class="last-name CharOverride-11">Sage </span><a href="#/Crown_Anthologies_epub#_idTextAnchor074"><span class="Character-Style-1 CharOverride-12">1</span></a></p></td>
<td> </td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Almaz </span><span class="last-name CharOverride-11">A.</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor071"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/almazspilledink" target="_blank">@almazspilledink</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Analog</span> <span class="last-name CharOverride-11">de Lēon </span><a href="#/Crown_Anthologies_epub#_idTextAnchor011"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor038"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor061"><span class="Character-Style-1 CharOverride-12">3</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor104"><span class="Character-Style-1 CharOverride-12">4</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor148"><span class="Character-Style-1 CharOverride-12">5</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor249"><span class="Character-Style-1 CharOverride-12">6</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/analog.words" target="_blank">@analog.words</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Andrew </span><span class="last-name CharOverride-11">Durst </span><a href="#/Crown_Anthologies_epub#_idTextAnchor053"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor242"><span class="Character-Style-1 CharOverride-12">2</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/andrewdurst" target="_blank">@andrewdurst</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">a</span><span class="CharOverride-11">ng</span><span class="CharOverride-11">ie</span><span class="last-name CharOverride-11">a</span><span class="last-name CharOverride-11">ll</span><span class="last-name CharOverride-11">e</span><span class="last-name CharOverride-11">n </span><a href="#/Crown_Anthologies_epub#_idTextAnchor078"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/angie.l.allen" target="_blank">@angie.l.allen</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">anna </span><span class="last-name CharOverride-11">corniffe </span><a href="#/Crown_Anthologies_epub#_idTextAnchor150"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/theannacorniffe" target="_blank">@theannacorniffe</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor027"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">A</span><span class="CharOverride-11">nth</span><span class="CharOverride-11">o</span><span class="CharOverride-11">ny </span><span class="last-name CharOverride-11">D</span><span class="last-name CharOverride-11">e</span><span class="last-name CharOverride-11">sm</span><span class="last-name CharOverride-11">o</span><span class="last-name CharOverride-11">nd </span><a href="#/Crown_Anthologies_epub#_idTextAnchor026"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/anthonydesmondpoetry" target="_blank">@anthonydesmondpoetry</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">A.R. </span><span class="last-name CharOverride-11">Asher </span><a href="#/Crown_Anthologies_epub#_idTextAnchor051"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor223"><span class="Character-Style-1 CharOverride-12">2</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/a.r.asher" target="_blank">@a.r.asher</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Ariadna </span><span class="last-name CharOverride-11">Blanco </span><a href="#/Crown_Anthologies_epub#_idTextAnchor184"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor218"><span class="Character-Style-1 CharOverride-12">2</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/voicelesswriter" target="_blank">@voicelesswriter</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor209"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="last-name CharOverride-11">a.r.lucas </span><a href="#/Crown_Anthologies_epub#_idTextAnchor210"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/a.r.lucas" target="_blank">@a.r.lucas</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Becca </span><span class="last-name CharOverride-11">Lee </span><a href="#/Crown_Anthologies_epub#_idTextAnchor082"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor202"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor235"><span class="Character-Style-1 CharOverride-12">3</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/beccaleepoetry" target="_blank">@beccaleepoetry</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Brittin </span><span class="last-name CharOverride-11">Oakman </span><a href="#/Crown_Anthologies_epub#_idTextAnchor161"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor176"><span class="Character-Style-1 CharOverride-12">2</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/b.oakman" target="_blank">@b.oakman</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Caroline </span><span class="last-name CharOverride-11">White </span><a href="#/Crown_Anthologies_epub#_idTextAnchor079"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/cwpoet" target="_blank">@cwpoet</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">C. </span><span class="last-name CharOverride-11">Churchill</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor236"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/cc_writes" target="_blank">@cc_writes</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Chase </span><span class="last-name CharOverride-11">Maser </span><a href="#/Crown_Anthologies_epub#_idTextAnchor049"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor131"><span class="Character-Style-1 CharOverride-12">2</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/pspoets" target="_blank">@pspoets</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Chr</span><span class="CharOverride-11">i</span><span class="CharOverride-11">st</span><span class="CharOverride-11">o</span><span class="CharOverride-11">ph</span><span class="CharOverride-11">e</span><span class="CharOverride-11">r </span><span class="last-name CharOverride-11">F</span><span class="last-name CharOverride-11">errei</span><span class="last-name CharOverride-11">r</span><span class="last-name CharOverride-11">a</span><span class="last-name CharOverride-11">s </span><a href="#/Crown_Anthologies_epub#_idTextAnchor009"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor080"><span class="Character-Style-1 CharOverride-12">2</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/itscarus" target="_blank">@itscarus</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor037"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Cindy </span><span class="last-name CharOverride-11">Cherie </span><a href="#/Crown_Anthologies_epub#_idTextAnchor036"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor183"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor208"><span class="Character-Style-1 CharOverride-12">3</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/cindycherie" target="_blank">@cindycherie</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">C. </span><span class="last-name CharOverride-11">Noel </span><a href="#/Crown_Anthologies_epub#_idTextAnchor055"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor213"><span class="Character-Style-1 CharOverride-12">2</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/noelsnotebook" target="_blank">@noelsnotebook</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Cobie </span><span class="last-name CharOverride-11">Kendra</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor166"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/cobiekendra" target="_blank">@cobiekendra</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor239"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="last-name CharOverride-11">d</span><span class="last-name CharOverride-11">á</span><span class="last-name CharOverride-11">eizm </span><a href="#/Crown_Anthologies_epub#_idTextAnchor238"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/daeizm" target="_blank">@daeizm</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor025"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Daniel </span><span class="last-name CharOverride-11">Saint </span><a href="#/Crown_Anthologies_epub#_idTextAnchor024"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor111"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor153"><span class="Character-Style-1 CharOverride-12">3</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/daniel.saint" target="_blank">@daniel.saint</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor032"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Daniel </span><span class="last-name CharOverride-11">Walsh </span><a href="#/Crown_Anthologies_epub#_idTextAnchor031"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor190"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor233"><span class="Character-Style-1 CharOverride-12">3</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/daniel.peter.walsh" target="_blank">@daniel.peter.walsh</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor127"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Daren </span><span class="last-name CharOverride-11">Colbert</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor128"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/darencolbert" target="_blank">@darencolbert</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Dave </span><span class="last-name CharOverride-11">Wise </span><a href="#/Crown_Anthologies_epub#_idTextAnchor152"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor178"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor193"><span class="Character-Style-1 CharOverride-12">3</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/d.a.wise" target="_blank">@d.a.wise</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor119"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Dru </span><span class="last-name CharOverride-11">Anthony </span><a href="#/Crown_Anthologies_epub#_idTextAnchor120"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor139"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor245"><span class="Character-Style-1 CharOverride-12">3</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/dru.anthony" target="_blank">@dru.anthony</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">E.G. </span><span class="last-name CharOverride-11">Cress </span><a href="#/Crown_Anthologies_epub#_idTextAnchor171"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/e.g.cress" target="_blank">@e.g.cress</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Emilija </span><span class="last-name CharOverride-11">Blum </span><a href="#/Crown_Anthologies_epub#_idTextAnchor070"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor118"><span class="Character-Style-1 CharOverride-12">2</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/emilijablum" target="_blank">@emilijablum</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Emina </span><span class="last-name CharOverride-11">Gašpar-Vrana </span><a href="#/Crown_Anthologies_epub#_idTextAnchor091"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor132"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor185"><span class="Character-Style-1 CharOverride-12">3</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/emina.gasparvrana" target="_blank">@emina.gasparvrana</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Erin </span><span class="last-name CharOverride-11">Van Vuren </span><a href="#/Crown_Anthologies_epub#_idTextAnchor064"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/papercrumbs" target="_blank">@papercrumbs</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="last-name CharOverride-11">faraway</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor054"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/farawaypoetry" target="_blank">@farawaypoetry</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="last-name CharOverride-11">featherdownsoul </span><a href="#/Crown_Anthologies_epub#_idTextAnchor047"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/featherdownsoul" target="_blank">@featherdownsoul</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor215"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Fiorella </span><span class="last-name CharOverride-11">Giordano </span><a href="#/Crown_Anthologies_epub#_idTextAnchor214"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/giordano.fiorella" target="_blank">@giordano.fiorella</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Gabrielle </span><span class="last-name CharOverride-11">Dufrene </span><a href="#/Crown_Anthologies_epub#_idTextAnchor076"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/4.26pm" target="_blank">@4.26pm</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Gabriel </span><span class="last-name CharOverride-11">Sage </span><a href="#/Crown_Anthologies_epub#_idTextAnchor057"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor066"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor075"><span class="Character-Style-1 CharOverride-12">3</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor081"><span class="Character-Style-1 CharOverride-12">4</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor252"><span class="Character-Style-1 CharOverride-12">5</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/gabrielsage" target="_blank">@gabrielsage</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">H. </span><span class="last-name CharOverride-11">Christoffersen </span><a href="#/Crown_Anthologies_epub#_idTextAnchor158"><span class="last-name CharOverride-13">1</span></a><span class="last-name CharOverride-13">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor179"><span class="last-name CharOverride-13">2</span></a><span class="last-name CharOverride-13">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor221"><span class="last-name CharOverride-13">3</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/hailey.christoffersen" target="_blank">@hailey.christoffersen</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Heidi </span><span class="last-name CharOverride-11">Kidd </span><a href="#/Crown_Anthologies_epub#_idTextAnchor250"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/heidi_the_untold" target="_blank">@heidi_the_untold</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Horacio </span><span class="last-name CharOverride-11">Jones </span><a href="#/Crown_Anthologies_epub#_idTextAnchor058"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor105"><span class="Character-Style-1 CharOverride-12">2</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/horaciojones" target="_blank">@horaciojones</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">israa </span><span class="last-name CharOverride-11">ismaeil </span><a href="#/Crown_Anthologies_epub#_idTextAnchor177"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/iaismaeil" target="_blank">@iaismaeil</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor103"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Jarod </span><span class="last-name CharOverride-11">W.</span><span class="CharOverride-11"> </span><a href="#/Crown_Anthologies_epub#_idTextAnchor102"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/rodandrew16" target="_blank">@rodandrew16</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">J. </span><span class="last-name CharOverride-11">Bird </span><a href="#/Crown_Anthologies_epub#_idTextAnchor022"><span class="last-name CharOverride-13">1</span></a><span class="last-name CharOverride-13">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor035"><span class="last-name CharOverride-13">2</span></a><span class="last-name CharOverride-13">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor067"><span class="last-name CharOverride-13">3</span></a><span class="last-name CharOverride-13">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor129"><span class="last-name CharOverride-13">4</span></a><span class="last-name CharOverride-13">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor168"><span class="last-name CharOverride-13">5</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/j.birdsmith" target="_blank">@j.birdsmith</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor124"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Jef </span><span class="last-name CharOverride-11">Joslin </span><a href="#/Crown_Anthologies_epub#_idTextAnchor123"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor164"><span class="Character-Style-1 CharOverride-12">2</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/jeffreyscottjoslinii" target="_blank">@jeffreyscottjoslinii</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Jess </span><span class="last-name CharOverride-11">Adams </span><a href="#/Crown_Anthologies_epub#_idTextAnchor157"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor199"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor203"><span class="Character-Style-1 CharOverride-12">3</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor244"><span class="Character-Style-1 CharOverride-12">4</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/jessadamsgrams" target="_blank">@jessadamsgrams</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Jessica </span><span class="last-name CharOverride-11">Michelle </span><a href="#/Crown_Anthologies_epub#_idTextAnchor217"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor247"><span class="Character-Style-1 CharOverride-12">2</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/_jessie.michelle_" target="_blank">@_jessie.michelle_</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">J. L. </span><span class="last-name CharOverride-11">Wyman </span><a href="#/Crown_Anthologies_epub#_idTextAnchor093"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor165"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor234"><span class="Character-Style-1 CharOverride-12">3</span></a><span class="Character-Style-1 CharOverride-12"> </span></p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/j.l.wyman" target="_blank">@j.l.wyman</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor121"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Joshua Ryan </span><span class="last-name CharOverride-11">Stewart</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor122"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/joshua_ryan_stewart" target="_blank">@joshua_ryan_stewart</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor189"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">J. Warren </span><span class="last-name CharOverride-11">Welch</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor188"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/j.warren.welch" target="_blank">@j.warren.welch</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Kate </span><span class="last-name CharOverride-11">Foster </span><a href="#/Crown_Anthologies_epub#_idTextAnchor062"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor114"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor232"><span class="Character-Style-1 CharOverride-12">3</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/kaitlin.foster" target="_blank">@kaitlin.foster</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="last-name CharOverride-11">Kay</span><span class="CharOverride-11">il </span><span class="last-name CharOverride-11">Crow </span><a href="#/Crown_Anthologies_epub#_idTextAnchor084"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor237"><span class="Character-Style-1 CharOverride-12">2</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/rose_thorns1921" target="_blank">@rose_thorns1921</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor227"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Kristen Laura </span><span class="last-name CharOverride-11">Costa </span><a href="#/Crown_Anthologies_epub#_idTextAnchor228"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/_kristenlaura" target="_blank">@_kristenlaura</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Kristina </span><span class="last-name CharOverride-11">Fanning</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor140"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/kristinafanning" target="_blank">@kristinafanning</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Krystal </span><span class="last-name CharOverride-11">Lorraine</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor159"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/krystal.lorraine" target="_blank">@krystal.lorraine</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Lauren </span><span class="last-name CharOverride-11">Eden </span><a href="#/Crown_Anthologies_epub#_idTextAnchor014"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor068"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor110"><span class="Character-Style-1 CharOverride-12">3</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/ofyesteryear" target="_blank">@ofyesteryear</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Leya </span><span class="last-name CharOverride-11">Noir </span><a href="#/Crown_Anthologies_epub#_idTextAnchor077"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/she.isawolf" target="_blank">@she.isawolf</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Madalyn </span><span class="last-name CharOverride-11">Beck </span><a href="#/Crown_Anthologies_epub#_idTextAnchor151"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12"> </span></p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/madalyn_beck" target="_blank">@madalyn_beck</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Marilyn </span><span class="last-name CharOverride-11">Carp </span><a href="#/Crown_Anthologies_epub#_idTextAnchor181"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor192"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor226"><span class="Character-Style-1 CharOverride-12">3</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/marilyn_carp" target="_blank">@marilyn_carp</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor212"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Mark </span><span class="last-name CharOverride-11">Anthony</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor211"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/markanthonypoet" target="_blank">@markanthonypoet</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor087"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">M. </span><span class="last-name CharOverride-11">FireChild </span><a href="#/Crown_Anthologies_epub#_idTextAnchor088"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor170"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor200"><span class="Character-Style-1 CharOverride-12">3</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor243"><span class="Character-Style-1 CharOverride-12">4</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/m.firechild" target="_blank">@m.firechild</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor040"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Michael </span><span class="last-name CharOverride-11">Layao </span><a href="#/Crown_Anthologies_epub#_idTextAnchor039"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor196"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor230"><span class="Character-Style-1 CharOverride-12">3</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/michael.layao" target="_blank">@michael.layao</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor085"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Michael Fawaz</span><span class="last-name CharOverride-11"> </span><a href="#/Crown_Anthologies_epub#_idTextAnchor086"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor175"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12"> </span></p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/coffeeshop_hero" target="_blank">@coffeeshop_hero</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Natalie </span><span class="last-name CharOverride-11">Jensen </span><a href="#/Crown_Anthologies_epub#_idTextAnchor044"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor069"><span class="Character-Style-1 CharOverride-12">2</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/__nataliejensen" target="_blank">@__nataliejensen</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor186"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Nazish </span><span class="last-name CharOverride-11">Akhtar </span><a href="#/Crown_Anthologies_epub#_idTextAnchor187"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/crownofwords" target="_blank">@crownofwords</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">N. </span><span class="last-name CharOverride-11">Wong </span><a href="#/Crown_Anthologies_epub#_idTextAnchor043"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor063"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor180"><span class="Character-Style-1 CharOverride-12">3</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor219"><span class="Character-Style-1 CharOverride-12">4</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/nicwoabode" target="_blank">@nicwoabode</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Olivia </span><span class="last-name CharOverride-11">Ku</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor090"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/olivia.ku" target="_blank">@olivia.ku</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Owen </span><span class="last-name CharOverride-11">Lindley</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor056"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/owen_lindley" target="_blank">@owen_lindley</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="last-name CharOverride-11">Paradox </span><span class="last-name CharOverride-14">&amp;</span><span class="last-name CharOverride-11"> Metaphors</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor113"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor155"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor220"><span class="Character-Style-1 CharOverride-12">3</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/_paradoxandmetaphors_" target="_blank">@_paradoxandmetaphors_</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Patrick </span><span class="last-name CharOverride-11">Hart </span><a href="#/Crown_Anthologies_epub#_idTextAnchor015"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/workinprogress13" target="_blank">@workinprogress13</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Rachel </span><span class="last-name CharOverride-11">Kay</span><span class="CharOverride-11"> </span><a href="#/Crown_Anthologies_epub#_idTextAnchor182"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/rkmusings" target="_blank">@rkmusings</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Raquel </span><span class="last-name CharOverride-11">Franco </span><a href="#/Crown_Anthologies_epub#_idTextAnchor136"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor143"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor167"><span class="Character-Style-1 CharOverride-12">3</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor194"><span class="Character-Style-1 CharOverride-12">4</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor207"><span class="Character-Style-1 CharOverride-12">5</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/raquelfranco.poet" target="_blank">@raquelfranco.poet</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Richard A. </span><span class="last-name CharOverride-11">Camus </span><a href="#/Crown_Anthologies_epub#_idTextAnchor012"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor028"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12"> </span> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/mister_paradoxal" target="_blank">@mister_paradoxal</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Richard A. </span><span class="last-name CharOverride-11">Camus</span><span class="CharOverride-11"> and Raquel </span><span class="last-name CharOverride-11">Franco </span><a href="#/Crown_Anthologies_epub#_idTextAnchor046"><span class="Character-Style-1 CharOverride-12">1</span></a><a href="#/Crown_Anthologies_epub#_idTextAnchor141"></a></p></td>
<td> </td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Rose </span><span class="last-name CharOverride-11">C.L. </span><a href="#/Crown_Anthologies_epub#_idTextAnchor142"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor195"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor204"><span class="Character-Style-1 CharOverride-12">3</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor216"><span class="Character-Style-1 CharOverride-12">4</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/roseclu" target="_blank">@roseclu</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Ruby </span><span class="last-name CharOverride-11">Dhal </span><a href="#/Crown_Anthologies_epub#_idTextAnchor042"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/r.dhalwriter" target="_blank">@r.dhalwriter</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor021"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">R. X. </span><span class="last-name CharOverride-11">Bird</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor020"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/r.x.bird" target="_blank">@r.x.bird</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor240"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Ryan </span><span class="last-name CharOverride-11">Hennessy</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor241"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/rdothennessy" target="_blank">@rdothennessy</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">r.z. </span><span class="last-name CharOverride-11">joyce</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor222"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/writer.r.z.joyce" target="_blank">@writer.r.z.joyce</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor145"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Salma </span><span class="last-name CharOverride-11">El-Wardany </span><a href="#/Crown_Anthologies_epub#_idTextAnchor144"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/salmaelwardany" target="_blank">@salmaelwardany</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Salman </span><span class="last-name CharOverride-11">Bharadia </span><a href="#/Crown_Anthologies_epub#_idTextAnchor154"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/salmanbharadia" target="_blank">@salmanbharadia</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Sarah </span><span class="last-name CharOverride-11">Doughty </span><a href="#/Crown_Anthologies_epub#_idTextAnchor108"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12"> </span></p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/thesarahdoughty" target="_blank">@thesarahdoughty</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Sarah </span><span class="last-name CharOverride-11">Janabi </span><a href="#/Crown_Anthologies_epub#_idTextAnchor174"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/immortal.thought" target="_blank">@immortal.thought</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Sarah </span><span class="last-name CharOverride-11">Maria</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor106"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/sarahmariawrites" target="_blank">@sarahmariawrites</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Shakespeare </span><a href="#/Crown_Anthologies_epub#_idTextAnchor004"><span class="Character-Style-1 CharOverride-12">1</span></a><a href="#/Crown_Anthologies_epub#_idTextAnchor034"></a></p></td>
<td> </td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Sica </span><span class="last-name CharOverride-11">Saccone </span><a href="#/Crown_Anthologies_epub#_idTextAnchor033"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor048"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor156"><span class="Character-Style-1 CharOverride-12">3</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/sica.says" target="_blank">@sica.says</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Simi </span><span class="last-name CharOverride-11">Fromen </span><a href="#/Crown_Anthologies_epub#_idTextAnchor115"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor251"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12"> </span> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/simi_fromen" target="_blank">@simi_fromen</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">S.L. </span><span class="last-name CharOverride-11">Gray </span><a href="#/Crown_Anthologies_epub#_idTextAnchor052"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/s.l._gray" target="_blank">@s.l._gray</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Soeline </span><span class="last-name CharOverride-11">Bosari </span><a href="#/Crown_Anthologies_epub#_idTextAnchor094"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor173"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor231"><span class="Character-Style-1 CharOverride-12">3</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/wordsbysoeline" target="_blank">@wordsbysoeline</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="last-name CharOverride-11">s.stepp </span><a href="#/Crown_Anthologies_epub#_idTextAnchor172"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/s.stepp" target="_blank">@s.stepp</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">stacie </span><span class="last-name CharOverride-11">martin </span><a href="#/Crown_Anthologies_epub#_idTextAnchor089"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/stacie.martin" target="_blank">@stacie.martin</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="last-name CharOverride-11">The Poetry Bandit </span><a href="#/Crown_Anthologies_epub#_idTextAnchor083"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor099"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor138"><span class="Character-Style-1 CharOverride-12">3</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor149"><span class="Character-Style-1 CharOverride-12">4</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/the_poetrybandit" target="_blank">@the_poetrybandit</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Topher </span><span class="last-name CharOverride-11">Kearby </span><a href="#/Crown_Anthologies_epub#_idTextAnchor010"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor107"><span class="Character-Style-1 CharOverride-12">2</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/topherkearby" target="_blank">@topherkearby</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">T. </span><span class="last-name CharOverride-11">Weiss </span><a href="#/Crown_Anthologies_epub#_idTextAnchor065"><span class="CharOverride-13">1</span></a><span class="CharOverride-13">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor072"><span class="CharOverride-13">2</span></a><span class="CharOverride-13">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor205"><span class="CharOverride-13">3</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/axiom.attic" target="_blank">@axiom.attic</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor117"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="last-name CharOverride-11">Tyler Knott Gregson  </span><a href="#/Crown_Anthologies_epub#_idTextAnchor000"><span class="last-name CharOverride-13">1</span></a></p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/tylerknott/" target="_blank">@tylerknott</a></span> </p></td>
</tr>
<tr>
<td><p class="index-text"><span class="last-name CharOverride-11">Unrulywords</span> <a href="#/Crown_Anthologies_epub#_idTextAnchor116"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/unrulywords" target="_blank">@unrulywords</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Vivi </span><span class="last-name CharOverride-11">Dale </span><a href="#/Crown_Anthologies_epub#_idTextAnchor017"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor030"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor050"><span class="Character-Style-1 CharOverride-12">3</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor224"><span class="Character-Style-1 CharOverride-12">4</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor246"><span class="Character-Style-1 CharOverride-12">5</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/vivi.dale" target="_blank">@vivi.dale</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="last-name CharOverride-11">Wilder </span><a href="#/Crown_Anthologies_epub#_idTextAnchor198"><span class="Character-Style-1 CharOverride-12">1</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/wilderpoetry" target="_blank">@wilderpoetry</a></span><a href="#/Crown_Anthologies_epub#_idTextAnchor125"></a></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Yasmin A. </span><span class="last-name CharOverride-11">Gomez </span><a href="#/Crown_Anthologies_epub#_idTextAnchor126"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor191"><span class="Character-Style-1 CharOverride-12">2</span></a><span class="Character-Style-1 CharOverride-12"> </span> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/yasmingomez.official" target="_blank">@yasmingomez.official</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Zachry K. </span><span class="last-name CharOverride-11">Douglas </span><a href="#/Crown_Anthologies_epub#_idTextAnchor130"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12">, </span><a href="#/Crown_Anthologies_epub#_idTextAnchor206"><span class="Character-Style-1 CharOverride-12">2</span></a> </p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/zachrykdouglas" target="_blank">@zachrykdouglas</a></span></p></td>
</tr>
<tr>
<td><p class="index-text"><span class="CharOverride-11">Zack </span><span class="last-name CharOverride-11">Grey </span><a href="#/Crown_Anthologies_epub#_idTextAnchor160"><span class="Character-Style-1 CharOverride-12">1</span></a><span class="Character-Style-1 CharOverride-12"> </span></p></td>
<td><p class="index-text"><span class="last-name CharOverride-11"><a href="https://www.instagram.com/zackgreywrites" target="_blank">@zackgreywrites</a></span></p></td>
</tr>
</tbody>
</table>
<div class="_idGenObjectStyleOverride-1" id="_idContainer244">
<p class="small-caps ParaOverride-4"><span class="CharOverride-3"><a id="_idTextAnchor256"></a>Acknowledgments</span></p>
</div>
<div class="_idGenObjectStyleOverride-1n" id="_idContainer245">
<p class="text"><a id="_idTextAnchor257"></a>Raise a glass . . .</p>
<p class="text t">This book was made possible by the tireless efforts of dedicated people and artists.</p>
<p class="text t">Vivi Dale, you are the backbone and the foundation of this book. More than a friend to every single person here, your perseverance and knowledge took this project to new heights.</p>
<p class="text t">Raquel Franco, thank you for your endless contributions. Your fingerprints are on every page. </p>
<p class="text t">M. FireChild, thank you for never giving up and for taking on some of the hardest challenges we faced. Every band of dreamers needs a fire child. </p>
<p class="text t">Sidd Long and Yasmin Gomez, thank you both for being pioneers. </p>
<p class="text t">To everyone else, thank you for your time, incredible dedication, and powerful words. Special thanks to: Fiorella Giordano, Cindy Cherie, Daniel Walsh, Jess Adams, Dru Anthony, Soeline Bosari, Jessica Michelle, N. Wong, Christopher Ferreiras, J. Bird, and Michael Fawaz.</p>
<p class="text t"><span class="CharOverride-2">Vive la Renaissance!</span></p>
<p class="text t">—Gabriel <span class="last-name CharOverride-6">&amp;</span> Analog</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer246">
<p class="small-caps ParaOverride-4"><span class="CharOverride-3"><a id="_idTextAnchor258"></a>About Lost Poets</span></p>
</div>
<div class="_idGenObjectStyleOverride-1n" id="_idContainer247">
<p class="text"><span class="CharOverride-2">Lost Poets</span> is a voice of resistance and hope, cofounded by Analog de Lēon and Gabriel Sage. Its books, events, and projects empower a global subculture of modern poets.</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer248">
<p class="small-caps ParaOverride-11"><span class="CharOverride-3">Crown Anthology</span></p>
<p class="text ParaOverride-3"><span class="CharOverride-15">copyright © 2018 by Chris Purifoy and Gabriel Sage. All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of reprints in the context of reviews.</span></p>
<p class="text ParaOverride-3 t"><span class="CharOverride-15">Andrews McMeel Publishing</span></p>
<p class="text ParaOverride-3"><span class="CharOverride-15">a division of Andrews McMeel Universal</span></p>
<p class="text ParaOverride-3"><span class="CharOverride-15">1130 Walnut Street, Kansas City, Missouri 64106</span></p>
<p class="text ParaOverride-3 t"><a href="http://www.andrewsmcmeel.com" target="_blank"><span class="CharOverride-15">www.andrewsmcmeel.com</span></a></p>
<p class="text ParaOverride-3 t"><span class="CharOverride-15">ISBN: 978-1-4494-9865-8</span></p>
<p class="text ParaOverride-3 t"><span class="CharOverride-15">Library of Congress Control Number: 2018939581</span></p>
<p class="text ParaOverride-3 t"><span class="CharOverride-15">Additional Editors:  Raquel Franco and Nicole Wong</span></p>
<p class="text ParaOverride-3"><span class="CharOverride-15">Cover illustration:  Alevtina Golovina</span></p>
<p class="text ParaOverride-3 t"><span class="CharOverride-15">Editor:  Patty Rice</span></p>
<p class="text ParaOverride-3"><span class="CharOverride-15">Designer, Art Director:  Diane Marsh</span></p>
<p class="text ParaOverride-3"><span class="CharOverride-15">Production Editor:  Elizabeth A. Garcia</span></p>
<p class="text ParaOverride-3"><span class="CharOverride-15">Production Manager:  Cliff Koehler</span></p>
<p class="text ParaOverride-3"><span class="CharOverride-15">Ebook Developer: Kristen Minter</span></p>
<p class="text ParaOverride-3 t"><span class="CharOverride-15">ATTENTION: SCHOOLS AND BUSINESSES</span></p>
<p class="text ParaOverride-3"><span class="CharOverride-15">Andrews McMeel books are available at quantity discounts with bulk purchase for educational, business, or sales promotional use. For information, please e-mail the Andrews McMeel Publishing Special Sales Department: </span><a href="mailto:specialsales@amuniversal.com"><span class="CharOverride-15">specialsales@amuniversal.com</span></a><span class="CharOverride-15">.</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer248b">
<p class="small-caps ParaOverride-11"><span class="CharOverride-3">Check out these other great titles from Andrews McMeel Publishing!</span></p>
<div class="_idGenObjectLayout-1">
<a href="http://publishing.andrewsmcmeel.com/books/detail?sku=9781449487621" target="_blank"><img alt="" class="_idGenObjectAttribute-1t" src="image/9781449497187.jpg" style="width: 30%;"/></a>
<a href="http://publishing.andrewsmcmeel.com/books/detail?sku=9781449492878" target="_blank">
<img alt="" class="_idGenObjectAttribute-1t" src="image/9781449492878.jpg" style="width: 30%;"/>
</a>
</div>
<div class="_idGenObjectLayout-1">
<a href="http://publishing.andrewsmcmeel.com/books/detail?sku=9781449492793" target="_blank">
<img alt="" class="_idGenObjectAttribute-1t" src="image/9781449496708.jpg" style="width: 30%;"/>
</a>
<a href="http://publishing.andrewsmcmeel.com/catalog/detail?sku=9781449474256" target="_blank">
<img alt="" class="_idGenObjectAttribute-1t" src="image/9781449474256.jpg" style="width: 30%;"/>
</a>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Crown_Anthologies_epub.vue?f7eea686